// Panchangam Data for January 2026
// Data provided directly in Tamil for accurate display

// Using ImageKit CDN for optimized image loading
const andal_malai = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/andal_malai_matram.jpg';
const radha_sapthami = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Jan_25_RathaSapthami.jpg';
const vidai_atru = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/IMG_20260115_184442.jpg';
const punnim = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Punnim.jpg';
const unjal_sevai = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Unjal_Sevai_Final.jpg';

// Vaikasi Vaganam Images
const day0 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_18_Chinna_Alzhagar.jpg?updatedAt=1769178433673'
const day1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_19_KappuKattu.jpg'
const day2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_20_Annam_Vaganam.jpg';
const day3 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_21_Singam_Vaganam.jpg';
const day4 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_22_Sesa_Vaganam.jpg';
const day5 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_23_Garuda_Vaganam.jpg';
const day6 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_24_Anumantha_Vaganam.jpg';
const day7 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_25_Yanai_Vaganam.jpg';
const day8 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_26_Thirukallayanam(2).jpg';
const day9 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_27_Vennaithali(1).jpg';
const day10 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/WhatsApp%20Image%202026-01-03%20at%2015.17.53.jpeg';
const day11 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_29_Therthavaari.jpg';
const day12 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/IMG-20250611-WA0085.jpg';
const day13 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_31_Kuthrai.jpg?updatedAt=1767874152472';
const day14 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Jun_1_Day_3.jpg';
const day15 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Jun_2_Day_4.jpg';
const day16 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Jun_3_Day_5.jpg';
const day17 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Dec_Month.jpg';
const day18 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/June_5_Kannadi_Sevai.jpg'
const day18_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/June_5_Kannadi_Sevai2.jpg'
const day19 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/June_6_Urchava_Santhi.jpg'
const day20 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/June_7_Kanthavadi_Urchavam.jpg'
const masimagam = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Punnim.jpg';
const ramanavami = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/March_27_Rama_Navami.jpg';
const ramanavami_kalyanam = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/March_28_Marraige.jpg'
const ramseetha_pallakku = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/IMG_20260109_230001.jpg'
const panguni_thirukalyanam = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Panguni_Uthiram(S)_Thirukalyanan.jpg';
const panguni_uthiram = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/_1010332.jpg'
const panguni_dhani = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Panguni_Uthiram_D5.jpg';
const tamilnewyear = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Tamil_New_Year.jpg';
const gajendra_motcham = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Gajendra%20Mokcham.jpg';
const ganupaari = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Aani_Kettai(S)_Sestaabhisegam.jpg'
const jestabisekam = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Aani_Kettai(S)_Sestaabhisegam.jpg'
const anandhaviradham = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/IMG_20260110_124508.jpg'
const vaigundam = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/IMG_20251229_222245.jpg'

//Pmk chithirai
const pmk_day_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-1.jpg';
const pmk_day_2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-2.jpg';
const pmk_day_3 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-3.jpg';
const pmk_day_4 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-4.jpg';
const pmk_day_5 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-5.jpg';
const pmk_day_6 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_1.jpg';
const pmk_day_7 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-7.jpg';
const pmk_day_8 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-8.jpg';
const pmk_day_9 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-9.jpg';
const pmk_day_10 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Pmk-day-10.jpg';
const pmk_day_10_1 = 'https://ik.imagekit.io/hskzc0fkv/WhatsApp%20Image%202026-01-08%20at%2002.21.55.jpeg'
const pmk_day_11 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/14.%20IMG-20250517-WA0017.jpg'

//Pmk aadi
const aadi1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi1.jpg';
const aadi2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi2.jpg';
const aadi3 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi3.jpg';
const aadi4 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi4.jpg';
const aadi5 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi5.jpg';
const aadi6 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi7.jpg';
const aadi7 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi6.jpg';
const aadi8 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi8.jpeg';
const aadi9 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi9.jpeg';
const aadi10 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi10.jpg';

const aadilastvelli = 'https://ik.imagekit.io/hskzc0fkv/Aadi%20last%20Friday.jpg'
const aadiamavasai = 'https://ik.imagekit.io/hskzc0fkv/aadiamavasai.jpeg'

const karthigai_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Karthikai_1%20(1).jpg'

const vijaya_dhasami = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Vijayadhasami.jpg';

const mandala_poojai = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/mandala%20abhisegam.jpg';
const srivari_bajanai = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Srivari%20bhajanai.jpg';

const srinivasan = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/108_Srinivasan.jpg';
const srinivasan_2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Srinivasan_108.jpg';

const thirumangai_alvar = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Karthigai_Chitrai(S)_Thirumangai_Azlvar.jpg';
const ramanujar_jeyanthi = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Ramanujar_Jayanthi.jpg'
const aadipooram = 'https://ik.imagekit.io/hskzc0fkv/Aadipooram.jpg'
const karthigai = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/karthigai.jpg'
const diwali = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Diwali.jpg'
const thaipusam = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Feb_1_Thaipusam.jpg'
const chakaram = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Chakarrathalvar_Jeyathi.jpg'
const diwali_garudan = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Aani_Kettai(S)_Sestaabhisegam.jpg'
const laksh_arjanai = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Laksh_Archanai.png'
const uriyadi = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Uriyadi%20urchavam.jpg'
const krishna_jayanthi = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Krishna_Jeyathi.jpg'

//Pmk Eswaran kovil

const pmk_eswaran_kovil_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day-1Moring.jpg?updatedAt=1767541063935'
const pmk_eswaran_kovil_2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day-2.2.jpg?updatedAt=1767541062545'
const pmk_eswaran_kovil_3 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day3.1.jpg?updatedAt=1767541164053'
const pmk_eswaran_kovil_3_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day3.2.jpg?updatedAt=1767541162696'
const pmk_eswaran_kovil_4 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day4.1.jpg?updatedAt=1767541157029'
const pmk_eswaran_kovil_4_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day4.2.jpg?updatedAt=1767541165313'
const pmk_eswaran_kovil_5 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day5.2.jpg?updatedAt=1767541161003'
const pmk_eswaran_kovil_5_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day5.1.jpg?updatedAt=1767541162481'
const pmk_eswaran_kovil_6 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day6.2.jpg?updatedAt=1767541153079'
// const pmk_eswaran_kovil_6_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day6.1.jpg?updatedAt=1767541165013'
const pmk_eswaran_kovil_7 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day-7.2.jpg?updatedAt=1767541072485'
// const pmk_eswaran_kovil_7_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day-7.1.jpg?updatedAt=1767541077984'
// const pmk_eswaran_kovil_7_2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day7.3.jpg?updatedAt=1767541171452'
const pmk_eswaran_kovil_8 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day8.0.jpg?updatedAt=1767541175533'
const pmk_eswaran_kovil_9 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day-9.jpg?updatedAt=1767541075756'
const pmk_eswaran_kovil_10 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day10.1.jpg?updatedAt=1767541068105'
// const pmk_eswaran_kovil_10_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Day10.2.jpg?updatedAt=1767541139815'
const pmk_eswaran_kovil_11 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/aadi10.jpg'


const navarathri_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar_Srinivasan2.jpg'
const navarathri_2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar%20(1).jpg'
const navarathri_3 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar%20(2).jpg'
const navarathri_4 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar(3).jpg'
const navarathri_5 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar_Oct15.jpg'
const navarathri_6 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar%20(5).jpg'
const navarathri_7 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar%20(6).jpg'
const navarathri_8 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar%20(7).jpg'
const navarathri_9 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Urchavar_Srinivasan.jpg'

const puratasi_1 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Purattachi_1.jpg'
const puratasi_2 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Purattachi_2.jpg'
const puratasi_3 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Purattachi_3.jpg'
const puratasi_4 = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/Purattachi_4.jpg'
const nadanagopal = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/IMG_20260110_205907.jpg'


const garudaPanjami = 'https://cdn.jsdelivr.net/gh/sridevarajankuzhumamems/SDK-CALENDAR-IMAGES/downloads/May_23_Garuda_Vaganam.jpg';

// Day types for color highlighting
export const DAY_TYPES = {
    MAJOR_FESTIVAL: "major_festival",  // Red highlight
    AUSPICIOUS: "auspicious",          // Yellow highlight
    REGULAR: "regular"                  // No special highlight
};

export const GOVT_HOLIDAY_NAMES = [
    "ஆங்கில புத்தாண்டு", "தை பொங்கல்", "மாட்டு பொங்கல்", "திருவள்ளுவர் தினம்",
    "உழவர் திருநாள்", "குடியரசு தினம்", "தைப்பூசம்", "தெலுங்கு வருடப்பிறப்பு",
    "ரம்ஜான்", "மகாவீர் ஜெயந்தி", "புனித வெள்ளி", "தமிழ் புத்தாண்டு",
    "அம்பேத்கர் ஜெயந்தி", "மே தினம்", "பக்ரீத்", "முஹர்ரம்", "இந்திய சுதந்திர தினம்",
    "மீலாத்-உன்-நபி", "கிருஷ்ண ஜெயந்தி", "விநாயகர் சதுர்த்தி", "காந்தி ஜெயந்தி",
    "ஆயுத பூஜை", "விஜயதசமி", "தீபாவளி", "கிறிஸ்துமஸ்", "காணும் பொங்கல்"
];

// Helper to determine day type from events
function getDayType(events) {
    if (!events || events.length === 0) return DAY_TYPES.REGULAR;

    const majorFestivals = [
        "தை பொங்கல்", "மாட்டு பொங்கல்", "காணும் பொங்கல்", "போகி",
        "குடியரசு தினம்", "ஆங்கில புத்தாண்டு", "தீபாவளி", "மகர சங்கராந்தி"
    ];

    const auspiciousEvents = [
        "பௌர்ணமி", "அமாவாசை", "ஏகாதசி", "திருவள்ளுவர் தினம்"
    ];

    if (events.some(e => GOVT_HOLIDAY_NAMES.includes(e))) return DAY_TYPES.MAJOR_FESTIVAL;
    if (events.some(e => majorFestivals.includes(e))) return DAY_TYPES.MAJOR_FESTIVAL;
    if (events.some(e => auspiciousEvents.includes(e))) return DAY_TYPES.AUSPICIOUS;

    return DAY_TYPES.AUSPICIOUS; // Default to auspicious for other named events
}

// January 2026 data from JSON with events.    //corrected-tamil-date and thithi
const JANUARY_2026_DATA = {
    1: { tamil_date: "மார்கழி 17", nakshatra: "ரோகிணி", tithi: "த்ரயோதசி", events: ["ஆங்கில புத்தாண்டு"] },
    2: { tamil_date: "மார்கழி 18", nakshatra: "மிருகசீரிடம்", tithi: "சதுர்த்தசி", events: [] },
    3: { tamil_date: "மார்கழி 19", nakshatra: "திருவாதிரை", tithi: "பௌர்ணமி", events: [] },
    4: { tamil_date: "மார்கழி 20", nakshatra: "புனர்பூசம்", tithi: "பிரதமை", events: [] },
    5: { tamil_date: "மார்கழி 21", nakshatra: "பூசம்", tithi: "துவிதியை", events: [] },
    6: { tamil_date: "மார்கழி 22", nakshatra: "ஆயில்யம்", tithi: "த்ரிதியை", events: [] },
    7: { tamil_date: "மார்கழி 23", nakshatra: "மகம்", tithi: "சதுர்த்தி", events: [] },
    8: { tamil_date: "மார்கழி 24", nakshatra: "பூரம்", tithi: "பஞ்சமி", events: [] },
    9: { tamil_date: "மார்கழி 25", nakshatra: "உத்திரம்", tithi: "ஷஷ்டி", events: [] },
    10: { tamil_date: "மார்கழி 26", nakshatra: "அஸ்தம்", tithi: "ஸப்தமி", events: [] },
    11: { tamil_date: "மார்கழி 27", nakshatra: "சித்திரை", tithi: "அஷ்டமி", events: ["கூடாரவல்லி(ஆண்டாள் வரதன் திருக்கல்யாணம்)", "ஏகாதசி"], image: andal_malai },
    12: { tamil_date: "மார்கழி 28", nakshatra: "சுவாதி", tithi: "நவமி", events: [] },
    13: { tamil_date: "மார்கழி 29", nakshatra: "விசாகம்", tithi: "தசமி", events: [] },
    14: { tamil_date: "மார்கழி 30", nakshatra: "அனுஷம்", tithi: "ஏகாதசி", events: ["போகி", "மகர சங்கராந்தி"] },
    15: { tamil_date: "தை 1", nakshatra: "கேட்டை", tithi: "துவாதசி", events: ["தை பொங்கல்", "ஆண்டாள் விடையாற்று உற்சவம்"], image: vidai_atru },
    16: { tamil_date: "தை 2", nakshatra: "மூலம்", tithi: "த்ரயோதசி", events: ["கணுப்பாரி உற்சவம்", "மாட்டு பொங்கல்", "திருவள்ளுவர் தினம்"], image: ganupaari },
    17: { tamil_date: "தை 3", nakshatra: "மூலம்", tithi: "சதுர்த்தசி", events: ["காணும் பொங்கல்", "உழவர் திருநாள்"] },
    18: { tamil_date: "தை 4", nakshatra: "பூராடம்", tithi: "அமாவாசை", events: ["அமாவாசை"] },
    19: { tamil_date: "தை 5", nakshatra: "உத்திராடம்", tithi: "பிரதமை", events: [] },
    20: { tamil_date: "தை 6", nakshatra: "திருவோணம்", tithi: "துவிதியை", events: [] },
    21: { tamil_date: "தை 7", nakshatra: "அவிட்டம்", tithi: "த்ரிதியை", events: [] },
    22: { tamil_date: "தை 8", nakshatra: "சதயம்", tithi: "சதுர்த்தி", events: [] },
    23: { tamil_date: "தை 9", nakshatra: "பூரட்டாதி", tithi: "பஞ்சமி", events: [] },
    24: { tamil_date: "தை 10", nakshatra: "உத்திரட்டாதி", tithi: "ஷஷ்டி", events: [] },
    25: { tamil_date: "தை 11", nakshatra: "ரேவதி", tithi: "ஸப்தமி", events: ["ரத சப்தமி"], image: radha_sapthami },
    26: { tamil_date: "தை 12", nakshatra: "அஸ்வினி", tithi: "அஷ்டமி", events: ["குடியரசு தினம்"] },
    27: { tamil_date: "தை 13", nakshatra: "பரணி", tithi: "நவமி", events: [] },
    28: { tamil_date: "தை 14", nakshatra: "கார்த்திகை", tithi: "தசமி", events: [] },
    29: { tamil_date: "தை 15", nakshatra: "ரோகிணி", tithi: "ஏகாதசி", events: [] },
    30: { tamil_date: "தை 16", nakshatra: "திருவாதிரை", tithi: "துவாதசி", events: [] },
    31: { tamil_date: "தை 17", nakshatra: "புனர்பூசம்", tithi: "த்ரயோதசி", events: [] }
};

// Process data to add dayType based on events
Object.keys(JANUARY_2026_DATA).forEach(day => {
    const data = JANUARY_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// February 2026 data from JSON with events
const FEBRUARY_2026_DATA = {
    1: { tamil_date: "தை 18", nakshatra: "பூசம்", tithi: "பௌர்ணமி", events: ["தைப்பூசம்"] },
    2: { tamil_date: "தை 19", nakshatra: "ஆயில்யம்", tithi: "பிரதமை", events: [] },
    3: { tamil_date: "தை 20", nakshatra: "மகம்", tithi: "துவிதியை", events: [] },
    4: { tamil_date: "தை 21", nakshatra: "பூரம்", tithi: "த்ரிதியை", events: [] },
    5: { tamil_date: "தை 22", nakshatra: "உத்திரம்", tithi: "சதுர்த்தி", events: [] },
    6: { tamil_date: "தை 23", nakshatra: "அஸ்தம்", tithi: "பஞ்சமி", events: [] },
    7: { tamil_date: "தை 24", nakshatra: "சித்திரை", tithi: "ஷஷ்டி", events: [] },
    8: { tamil_date: "தை 25", nakshatra: "சுவாதி", tithi: "ஸப்தமி", events: [] },
    9: { tamil_date: "தை 26", nakshatra: "விசாகம்", tithi: "அஷ்டமி", events: [] },
    10: { tamil_date: "தை 27", nakshatra: "விசாகம்", tithi: "அஷ்டமி", events: [] },
    11: { tamil_date: "தை 28", nakshatra: "அனுஷம்", tithi: "நவமி", events: [] },
    12: { tamil_date: "தை 29", nakshatra: "கேட்டை", tithi: "தசமி", events: [] },
    13: { tamil_date: "மாசி 1", nakshatra: "மூலம்", tithi: "ஏகாதசி", events: ["மாசி மாதம் தொடக்கம்", "ஏகாதசி"] },
    14: { tamil_date: "மாசி 2", nakshatra: "பூராடம்", tithi: "துவாதசி", events: ["வாலண்டைன்ஸ் டே"] },
    15: { tamil_date: "மாசி 3", nakshatra: "உத்திராடம்", tithi: "த்ரயோதசி", events: [] },
    16: { tamil_date: "மாசி 4", nakshatra: "திருவோணம்", tithi: "சதுர்த்தசி", events: ["மாத சிவராத்திரி"] },
    17: { tamil_date: "மாசி 5", nakshatra: "அவிட்டம்", tithi: "அமாவாசை", events: ["அமாவாசை"] },
    18: { tamil_date: "மாசி 6", nakshatra: "சதயம்", tithi: "பிரதமை", events: [] },
    19: { tamil_date: "மாசி 7", nakshatra: "பூரட்டாதி", tithi: "துவிதியை", events: [] },
    20: { tamil_date: "மாசி 8", nakshatra: "உத்திரட்டாதி", tithi: "த்ரிதியை", events: [] },
    21: { tamil_date: "மாசி 9", nakshatra: "ரேவதி", tithi: "சதுர்த்தி", events: [] },
    22: { tamil_date: "மாசி 10", nakshatra: "அஸ்வினி", tithi: "பஞ்சமி", events: [] },
    23: { tamil_date: "மாசி 11", nakshatra: "பரணி", tithi: "ஷஷ்டி", events: [] },
    24: { tamil_date: "மாசி 12", nakshatra: "கார்த்திகை", tithi: "ஸப்தமி", events: [] },
    25: { tamil_date: "மாசி 13", nakshatra: "ரோகிணி", tithi: "நவமி", events: [] },
    26: { tamil_date: "மாசி 14", nakshatra: "மிருகசீரிடம்", tithi: "தசமி", events: [] },
    27: { tamil_date: "மாசி 15", nakshatra: "திருவாதிரை", tithi: "ஏகாதசி", events: [] },
    28: { tamil_date: "மாசி 16", nakshatra: "புனர்பூசம்", tithi: "துவாதசி", events: ["ஏகாதசி"] }
};

// Process February data
Object.keys(FEBRUARY_2026_DATA).forEach(day => {
    const data = FEBRUARY_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});


const MARCH_2026_DATA = {
    1: { tamil_date: "மாசி 17", nakshatra: "பூசம்", tithi: "த்ரயோதசி", events: [] },
    2: { tamil_date: "மாசி 18", nakshatra: "ஆயில்யம்", tithi: "சதுர்த்தசி", events: [] },
    3: { tamil_date: "மாசி 19", nakshatra: "மகம்", tithi: "பௌர்ணமி", events: [] },
    4: { tamil_date: "மாசி 20", nakshatra: "பூரம்", tithi: "பிரதமை", events: [] },
    5: { tamil_date: "மாசி 21", nakshatra: "உத்திரம்", tithi: "துவிதியை", events: [] },
    6: { tamil_date: "மாசி 22", nakshatra: "அஸ்தம்", tithi: "த்ரிதியை", events: [] },
    7: { tamil_date: "மாசி 23", nakshatra: "சித்திரை", tithi: "சதுர்த்தி", events: [] },
    8: { tamil_date: "மாசி 24", nakshatra: "சுவாதி", tithi: "பஞ்சமி", events: [] },
    9: { tamil_date: "மாசி 25", nakshatra: "விசாகம்", tithi: "ஷஷ்டி", events: [] },
    10: { tamil_date: "மாசி 26", nakshatra: "அனுஷம்", tithi: "ஸப்தமி", events: [] },
    11: { tamil_date: "மாசி 27", nakshatra: "கேட்டை", tithi: "அஷ்டமி", events: [] },
    12: { tamil_date: "மாசி 28", nakshatra: "மூலம்", tithi: "நவமி", events: [] },
    13: { tamil_date: "மாசி 29", nakshatra: "பூராடம்", tithi: "தசமி", events: [] },
    14: { tamil_date: "மாசி 30", nakshatra: "உத்திராடம்", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },

    15: { tamil_date: "பங்குனி 1", nakshatra: "திருவோணம்", tithi: "துவாதசி", events: ["பங்குனி மாதம் தொடக்கம்"] },
    16: { tamil_date: "பங்குனி 2", nakshatra: "அவிட்டம்", tithi: "த்ரயோதசி", events: [] },
    17: { tamil_date: "பங்குனி 3", nakshatra: "அவிட்டம்", tithi: "சதுர்த்தசி", events: [] },
    18: { tamil_date: "பங்குனி 4", nakshatra: "பூரட்டாதி", tithi: "அமாவாசை", events: ["அமாவாசை"] },
    19: { tamil_date: "பங்குனி 5", nakshatra: "உத்திரட்டாதி", tithi: "பிரதமை", events: ["தெலுங்கு வருடப்பிறப்பு"] },
    20: { tamil_date: "பங்குனி 6", nakshatra: "ரேவதி", tithi: "துவிதியை", events: [] },
    21: { tamil_date: "பங்குனி 7", nakshatra: "அஸ்வினி", tithi: "த்ரிதியை", events: ["ரம்ஜான்"] },
    22: { tamil_date: "பங்குனி 8", nakshatra: "பரணி", tithi: "சதுர்த்தி", events: [] },
    23: { tamil_date: "பங்குனி 9", nakshatra: "கார்த்திகை", tithi: "பஞ்சமி", events: [] },
    24: { tamil_date: "பங்குனி 10", nakshatra: "ரோகிணி", tithi: "ஷஷ்டி", events: [] },
    25: { tamil_date: "பங்குனி 11", nakshatra: "மிருகசீரிடம்", tithi: "ஸப்தமி", events: [] },
    26: { tamil_date: "பங்குனி 12", nakshatra: "திருவாதிரை", tithi: "அஷ்டமி", events: [] },
    27: { tamil_date: "பங்குனி 13", nakshatra: "புனர்பூசம்", tithi: "நவமி", events: [] },
    28: { tamil_date: "பங்குனி 14", nakshatra: "பூசம்", tithi: "தசமி", events: ["ராம சீதா திருக்கல்யாணம்"], image: ramanavami_kalyanam },
    29: { tamil_date: "பங்குனி 15", nakshatra: "ஆயில்யம்", tithi: "ஏகாதசி", events: ["சீதா ராம புஷ்ப பல்லக்கு", "ஏகாதசி"], image: ramseetha_pallakku },
    30: { tamil_date: "பங்குனி 16", nakshatra: "மகம்", tithi: "துவாதசி", events: [] },
    31: { tamil_date: "பங்குனி 17", nakshatra: "பூரம்", tithi: "த்ரயோதசி", events: ["மகாவீர் ஜெயந்தி"] }
};



// Process March data
Object.keys(MARCH_2026_DATA).forEach(day => {
    const data = MARCH_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// April 2026 data from JSON with events
const APRIL_2026_DATA = {
    1: { tamil_date: "பங்குனி 18", nakshatra: "உத்திரம்", tithi: "சதுர்த்தசி", events: ['பெருந்தேவி வரதன் திருக்கல்யாணம்'] },
    2: { tamil_date: "பங்குனி 19", nakshatra: "அஸ்தம்", tithi: "பௌர்ணமி", events: [] },
    3: { tamil_date: "பங்குனி 20", nakshatra: "சித்திரை", tithi: "பிரதமை", events: ["புனித வெள்ளி"] },
    4: { tamil_date: "பங்குனி 21", nakshatra: "சுவாதி", tithi: "த்விதியை", events: [] },
    5: { tamil_date: "பங்குனி 22", nakshatra: "விசாகம்", tithi: "த்ரிதியை", events: ["பங்குனி புஷ்பப்பல்லக்கு", "ஈஸ்டர்", "சங்கடஹர சதுர்த்தி"] },
    6: { tamil_date: "பங்குனி 23", nakshatra: "அனுஷம்", tithi: "சதுர்த்தி", events: [] },
    7: { tamil_date: "பங்குனி 24", nakshatra: "கேட்டை", tithi: "பஞ்சமி", events: [] },
    8: { tamil_date: "பங்குனி 25", nakshatra: "மூலம்", tithi: "ஷஷ்டி", events: ["ஷஷ்டி விரதம்"] },
    9: { tamil_date: "பங்குனி 26", nakshatra: "மூலம்", tithi: "ஸப்தமி", events: [] },
    10: { tamil_date: "பங்குனி 27", nakshatra: "பூராடம்", tithi: "அஷ்டமி", events: [] },
    11: { tamil_date: "பங்குனி 28", nakshatra: "உத்திராடம்", tithi: "நவமி", events: [] },
    12: { tamil_date: "பங்குனி 29", nakshatra: "திருவோணம்", tithi: "தசமி", events: [] },
    13: { tamil_date: "பங்குனி 30", nakshatra: "அவிட்டம்", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },
    14: { tamil_date: "சித்திரை 1", nakshatra: "சதயம்", tithi: "த்வாதசி", events: ["தமிழ் புத்தாண்டு", "அம்பேத்கர் ஜெயந்தி"] },
    15: { tamil_date: "சித்திரை 2", nakshatra: "பூரட்டாதி", tithi: "த்ரயோதசி", events: ["மாத சிவராத்திரி", "விஷு"] },
    16: { tamil_date: "சித்திரை 3", nakshatra: "உத்திரட்டாதி", tithi: "சதுர்த்தசி", events: [] },
    17: { tamil_date: "சித்திரை 4", nakshatra: "ரேவதி", tithi: "அமாவாசை", events: ["அமாவாசை"] },
    18: { tamil_date: "சித்திரை 5", nakshatra: "அஸ்வினி", tithi: "பிரதமை", events: [] },
    19: { tamil_date: "சித்திரை 6", nakshatra: "பரணி", tithi: "த்விதியை", events: ["அக்ஷய திருதியை"] },
    20: { tamil_date: "சித்திரை 7", nakshatra: "கார்த்திகை", tithi: "த்ரிதியை", events: ["பரமக்குடி ஈஸ்வரன் கோவில் கொடியேற்றம்"] },
    21: { tamil_date: "சித்திரை 8", nakshatra: "மிருகசீரிடம்", tithi: "பஞ்சமி", events: ["இரண்டாம் நாள் இரவு நந்திகேஸ்வரர் & கிளி"] },
    22: { tamil_date: "சித்திரை 9", nakshatra: "திருவாதிரை", tithi: "ஷஷ்டி", events: ["மூன்றாம் நாள் இரவு குண்டோதர வாகனம் & சிம்ம வாகனம்"] },
    23: { tamil_date: "சித்திரை 10", nakshatra: "புனர்பூசம்", tithi: "ஸப்தமி", events: ["நான்காம் நாள் இரவு கைலாச கார்ப்பகவிருட்சம் & அன்ன வாகனம்"] },
    24: { tamil_date: "சித்திரை 11", nakshatra: "பூசம்", tithi: "அஷ்டமி", events: ["ஐந்தாம் நாள் இரவு இராவண கைலாசம் & காமதேனு வாகனம்"] },
    25: { tamil_date: "சித்திரை 12", nakshatra: "ஆயில்யம்", tithi: "நவமி", events: ["ஆறாம் நாள் இரவு விருஷப சேவை"] },
    26: { tamil_date: "சித்திரை 13", nakshatra: "மகம்", tithi: "தசமி", events: ["ஏழாம் நாள் குதிரை வாகனம் திக் விஜயம்", "ஸ்ரீ சுந்தரராஜப் பெருமாள் முதல் நாள் திருநாள்"] },
    27: { tamil_date: "சித்திரை 14", nakshatra: "பூரம்", tithi: "ஏகாதசி", events: ["எட்டாம் நாள் இரவு அம்பாள் கதிர் குளித்தல் பல்லக்கு", "ஸ்ரீ சுந்தரராஜப் பெருமாள் இரண்டாம் நாள் திருநாள்", "ஏகாதசி"] },
    28: { tamil_date: "சித்திரை 15", nakshatra: "உத்திரம் ", tithi: "த்வாதசி", events: ["ஒன்பதாம் நாள் காலை மீனாட்சி திருக்கல்யாணம்  & இரவு பட்டணப்பிரவேசம்", "ஸ்ரீ சுந்தரராஜப் பெருமாள் மூன்றாம் நாள் திருநாள்"] },
    29: { tamil_date: "சித்திரை 16", nakshatra: "அஸ்தம்", tithi: "த்ரயோதசி", events: ["பத்தாம் நாள் காலை ரதாரோஹணம் & இரவு சப்தாவரணம்", "ஸ்ரீ சுந்தரராஜப் பெருமாள் நான்காம் நாள் திருநாள்"] },
    30: { tamil_date: "சித்திரை 17", nakshatra: "சித்திரை", tithi: "சதுர்த்தசி", events: ["பதினொன்றம் நாள் தீர்த்தவாரி", "சுந்தரராஜப் பெருமாள் கள்ளர் திருக்கோலத்தில் வைகை எழுந்தருளல்", "நரசிம்ம ஜெயந்தி"] }
};

// Process April data
Object.keys(APRIL_2026_DATA).forEach(day => {
    const data = APRIL_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// May 2026 data from JSON with events

const MAY_2026_DATA = {
    1: { tamil_date: "சித்திரை 18", nakshatra: "ஸ்வாதி", tithi: "பௌர்ணமி", events: ["குதிரை வாகனம் வண்டியூர் திருவிழா", "மே தினம்"] },
    2: { tamil_date: "சித்திரை 19", nakshatra: "விசாகம்", tithi: "பிரதமை", events: ["சேஷ வாகனம் மண்டூக மகரிஷி சாப விமோசனம்"] },
    3: { tamil_date: "சித்திரை 20", nakshatra: "விசாகம்", tithi: "த்விதியை", events: ["பெரிய திருவடி கருட வாகனம்", "சங்கடஹர சதுர்த்தி"] },
    4: { tamil_date: "சித்திரை 21", nakshatra: "அனுஷம்", tithi: "த்ரிதியை", events: ["ராஜாங்க சேவை"] },
    5: { tamil_date: "சித்திரை 22", nakshatra: "கேட்டை", tithi: "சதுர்த்தி", events: ["கள்ளர் திருக்கோலத்தில் ஆஸ்தானத்தை நோக்கி இரவு கண்ணாடி சேவை"] },
    6: { tamil_date: "சித்திரை 23", nakshatra: "மூலம்", tithi: "சதுர்த்தி", events: ["உற்சவ சாந்தி", "ஷஷ்டி விரதம்"] },
    7: { tamil_date: "சித்திரை 24", nakshatra: "பூராடம்", tithi: "பஞ்சமி", events: [] },
    8: { tamil_date: "சித்திரை 25", nakshatra: "உத்திராடம்", tithi: "பஞ்சமி", events: [] },
    9: { tamil_date: "சித்திரை 26", nakshatra: "திருவோணம்", tithi: "ஸப்தமி", events: [] },
    10: { tamil_date: "சித்திரை 27", nakshatra: "அவிட்டம்", tithi: "அஷ்டமி", events: [] },
    11: { tamil_date: "சித்திரை 28", nakshatra: "சதயம்", tithi: "நவமி", events: ["ஏகாதசி"] },
    12: { tamil_date: "சித்திரை 29", nakshatra: "பூரட்டாதி", tithi: "தசமி", events: [] },
    13: { tamil_date: "சித்திரை 30", nakshatra: "உத்திரட்டாதி", tithi: "ஏகாதசி", events: ["மாத சிவராத்திரி", "பிரதோஷம்"] },
    14: { tamil_date: "சித்திரை 31", nakshatra: "ரேவதி", tithi: "த்வாதசி", events: ["வைகாசி மாதம் தொடக்கம்"] },
    15: { tamil_date: "வைகாசி 1", nakshatra: "அஸ்வினி", tithi: "த்ரயோதசி", events: [] },
    16: { tamil_date: "வைகாசி 2", nakshatra: "பரணி", tithi: "அமாவாசை", events: ["அமாவாசை"] },
    17: { tamil_date: "வைகாசி 3", nakshatra: "கார்த்திகை", tithi: "த்விதியை", events: [] },
    18: { tamil_date: "வைகாசி 4", nakshatra: "ரோகிணி", tithi: "த்ரிதியை", events: ["2018 & 2019 சின்ன அழகர்"] },
    19: { tamil_date: "வைகாசி 5", nakshatra: "மிருகசீரிடம்", tithi: "சதுர்த்தி", events: ["ஸ்ரீ வரதராஜப் பெருமாள் 224வது பிரமோற்சவம் ஆரம்பம் இரவு காப்புக் கட்டு", "சங்கடஹர சதுர்த்தி"] },
    20: { tamil_date: "வைகாசி 6", nakshatra: "திருவாதிரை", tithi: "பஞ்சமி", events: ["முதல் நாள் காலை த்வஜாரோஹணம் இரவு அன்ன வாகனம்"] },
    21: { tamil_date: "வைகாசி 7", nakshatra: "பூசம்", tithi: "ஷஷ்டி", events: ["இரண்டாம் நாள் காலை ரெங்கமன்னார் திருப்பல்லக்கு - இரவு சிம்ம வாகனம்", "ஷஷ்டி விரதம்"] },
    22: { tamil_date: "வைகாசி 8", nakshatra: "ஆயில்யம்", tithi: "ஸப்தமி", events: ["மூன்றாம் நாள் காலை ராமர் சேவை திருப்பல்லக்கு — இரவு சேஷ வாகனம்", "வைகாசி விசாகம்"] },
    23: { tamil_date: "வைகாசி 9", nakshatra: "மகம்", tithi: "அஷ்டமி", events: ["நான்காம் நாள் காலை காளிங்க நர்த்தனம் திருப்பல்லக்கு — இரவு பெரிய திருவடி"] },
    24: { tamil_date: "வைகாசி 10", nakshatra: "பூரம்", tithi: "நவமி", events: ["ஐந்தாம் நாள் காலை குழலூதும்பிரான் திருப்பல்லக்கு — இரவு சிறிய திருவடி"] },
    25: { tamil_date: "வைகாசி 11", nakshatra: "உத்திரம்", tithi: "தசமி", events: ["ஆறாம் நாள் காலை கீதோபதேச திருப்பல்லக்கு — இரவு யானை வாகனம்"] },
    26: { tamil_date: "வைகாசி 12", nakshatra: "அஸ்தம்", tithi: "ஏகாதசி", events: ["ஏழாம் நாள் காலை ஸ்ரீதேவி பூதேவி திருக்கல்யாணம் - இரவு சூர்ணோத்ஸவம்.", "ஏகாதசி"] },
    27: { tamil_date: "வைகாசி 13", nakshatra: "அஸ்தம்", tithi: "த்வாதசி", events: ["எட்டாம் நாள் மாலை வெண்ணைத்தாழி நவநீத கிருஷ்ணன் சேவை"] },
    28: { tamil_date: "வைகாசி 14", nakshatra: "சித்திரை", tithi: "த்ரயோதசி", events: ["ஒன்பதாம் நாள் அதிகாலை குதிரை வாகனம் - மாலை ரதாரோஹணம் - இரவு சப்தாவரணம்", "பிரதோஷம்", "பக்ரீத்"] },
    29: { tamil_date: "வைகாசி 15", nakshatra: "சுவாதி", tithi: "சதுர்த்தசி", events: ["பத்தாம் நாள் காலை தீர்த்தவாரி இரவு த்வஜாவரோஹணம்"] },
    30: { tamil_date: "வைகாசி 16", nakshatra: "விசாகம்", tithi: "பௌர்ணமி", events: ["ஸ்ரீ வரதராஜப் பெருமாள் 119வது வசந்தோத்ஸவம் முதல் நாள் கள்ளர் திருக்கோலத்தில் வைகை எழுந்தருளல்"] },
    31: { tamil_date: "வைகாசி 17", nakshatra: "அனுஷம்", tithi: "பிரதமை", events: ["குதிரை வாகனம் வண்டியூர் திருவிழா"] }
};


// Process May data
Object.keys(MAY_2026_DATA).forEach(day => {
    const data = MAY_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// June 2026 data from JSON with events
const JUNE_2026_DATA = {
    1: { tamil_date: "வைகாசி 18", nakshatra: "கேட்டை", tithi: "பிரதமை", events: ["சேஷ வாகனம் மண்டூக மகரிஷி சாப விமோசனம்"] },
    2: { tamil_date: "வைகாசி 19", nakshatra: "மூலம்", tithi: "த்விதியை", events: ["பெரிய திருவடி கருட வாகனம்"] },
    3: { tamil_date: "வைகாசி 20", nakshatra: "பூராடம்", tithi: "த்ரிதியை", events: ["சிறிய திருவடி அனுமந்த வாகனம்"] },
    4: { tamil_date: "வைகாசி 21", nakshatra: "உத்திராடம்", tithi: "சதுர்த்தி", events: ["கள்ளர் திருக்கோலத்தில் ஆஸ்தானத்தை நோக்கி புறப்படுதல்", "சங்கடஹர சதுர்த்தி"] },
    5: { tamil_date: "வைகாசி 22", nakshatra: "திருவோணம்", tithi: "பஞ்சமி", events: ["காலை ஆஸ்தானத்தை அடைதல் இரவு கண்ணாடி சேவை"] },
    6: { tamil_date: "வைகாசி 23", nakshatra: "திருவோணம்", tithi: "ஷஷ்டி", events: ["உற்சவ சாந்தி"] },
    7: { tamil_date: "வைகாசி 24", nakshatra: "அவிட்டம்", tithi: "ஸப்தமி", events: ["கந்தவடி உற்சவம்"] },
    8: { tamil_date: "வைகாசி 25", nakshatra: "சதயம்", tithi: "அஷ்டமி", events: [] },
    9: { tamil_date: "வைகாசி 26", nakshatra: "பூரட்டாதி", tithi: "நவமி", events: [] },
    10: { tamil_date: "வைகாசி 27", nakshatra: "உத்திரட்டாதி", tithi: "தசமி", events: [] },
    11: { tamil_date: "வைகாசி 28", nakshatra: "ரேவதி", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },
    12: { tamil_date: "வைகாசி 29", nakshatra: "அஸ்வினி", tithi: "த்வாதசி", events: ["பிரதோஷம்"] },
    13: { tamil_date: "வைகாசி 30", nakshatra: "கார்த்திகை", tithi: "த்ரயோதசி", events: ["மாச சிவராத்திரி"] },
    14: { tamil_date: "வைகாசி 31", nakshatra: "ரோகிணி", tithi: "சதுர்த்தசி", events: ["ஆனி மாதம் தொடக்கம்"] },
    15: { tamil_date: "ஆனி 1", nakshatra: "மிருகசீரிடம்", tithi: "அமாவாசை", events: ["அமாவாசை"] },
    16: { tamil_date: "ஆனி 2", nakshatra: "திருவாதிரை", tithi: "த்விதியை", events: [] },
    17: { tamil_date: "ஆனி 3", nakshatra: "புனர்பூசம்", tithi: "த்ரிதியை", events: [] },
    18: { tamil_date: "ஆனி 4", nakshatra: "பூசம்", tithi: "சதுர்த்தி", events: [] },
    19: { tamil_date: "ஆனி 5", nakshatra: "ஆயில்யம்", tithi: "பஞ்சமி", events: [] },
    20: { tamil_date: "ஆனி 6", nakshatra: "மகம்", tithi: "ஷஷ்டி", events: [] },
    21: { tamil_date: "ஆனி 7", nakshatra: "பூரம்", tithi: "ஸப்தமி", events: [] },
    22: { tamil_date: "ஆனி 8", nakshatra: "உத்திரம்", tithi: "அஷ்டமி", events: ["ஆனி உதிரம்", "வ்ரிஷப வ்ரதம்"] },
    23: { tamil_date: "ஆனி 9", nakshatra: "அஸ்தம்", tithi: "நவமி", events: [] },
    24: { tamil_date: "ஆனி 10", nakshatra: "சித்திரை", tithi: "தசமி", events: [] },
    25: { tamil_date: "ஆனி 11", nakshatra: "சுவாதி", tithi: "ஏகாதசி", events: [] },
    26: { tamil_date: "ஆனி 12", nakshatra: "விசாகம்", tithi: "த்வாதசி", events: ["பிரதோஷம்", "முஹர்ரம்"] },
    27: { tamil_date: "ஆனி 13", nakshatra: "அனுஷம்", tithi: "த்ரயோதசி", events: [] },
    28: { tamil_date: "ஆனி 14", nakshatra: "கேட்டை", tithi: "சதுர்த்தசி", events: [] },
    29: { tamil_date: "ஆனி 15", nakshatra: "மூலம்", tithi: "பௌர்ணமி", events: ["சாவித்ரி விரதம்"] },
    30: { tamil_date: "ஆனி 16", nakshatra: "பூராடம்", tithi: "பிரதமை", events: [] }
};

// Process June data
Object.keys(JUNE_2026_DATA).forEach(day => {
    const data = JUNE_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// July 2026 data from JSON with events
const JULY_2026_DATA = {
    1: { tamil_date: "ஆனி 17", nakshatra: "அவிட்டம்", tithi: "பிரதமை", events: [] },
    2: { tamil_date: "ஆனி 18", nakshatra: "சதயம்", tithi: "த்விதியை", events: [] },
    3: { tamil_date: "ஆனி 19", nakshatra: "பூரட்டாதி", tithi: "த்ரிதியை", events: ["சங்கடஹர சதுர்த்தி"] },
    4: { tamil_date: "ஆனி 20", nakshatra: "உத்திரட்டாதி", tithi: "சதுர்த்தி", events: [] },
    5: { tamil_date: "ஆனி 21", nakshatra: "ரேவதி", tithi: "பஞ்சமி", events: ["ஷஷ்டி விரதம்"] },
    6: { tamil_date: "ஆனி 22", nakshatra: "அஸ்வினி", tithi: "ஷஷ்டி", events: [] },
    7: { tamil_date: "ஆனி 23", nakshatra: "பரணி", tithi: "ஸப்தமி", events: [] },
    8: { tamil_date: "ஆனி 24", nakshatra: "கார்த்திகை", tithi: "அஷ்டமி", events: [] },
    9: { tamil_date: "ஆனி 25", nakshatra: "ரோகிணி", tithi: "நவமி", events: [] },
    10: { tamil_date: "ஆனி 26", nakshatra: "மிருகசீரிடம்", tithi: "தசமி", events: [] },
    11: { tamil_date: "ஆனி 27", nakshatra: "திருவாதிரை", tithi: "த்வாதசி", events: ["பிரதோஷம்"] },
    12: { tamil_date: "ஆனி 28", nakshatra: "புனர்பூசம்", tithi: "த்ரயோதசி", events: ["மாத சிவராத்திரி"] },
    13: { tamil_date: "ஆனி 29", nakshatra: "பூசம்", tithi: "சதுர்த்தசி", events: [] },
    14: { tamil_date: "ஆனி 30", nakshatra: "ஆயில்யம்", tithi: "அமாவாசை", events: ["ஆடி மாதம் தொடக்கம்", "அமாவாசை"] },
    15: { tamil_date: "ஆனி 31", nakshatra: "மகம்", tithi: "பிரதமை", events: [] },
    16: { tamil_date: "ஆனி 32", nakshatra: "பூரம்", tithi: "த்விதியை", events: [] },
    17: { tamil_date: "ஆடி 1", nakshatra: "உத்திரம்", tithi: "த்ரிதியை", events: [] },
    18: { tamil_date: "ஆடி 2", nakshatra: "அஸ்தம்", tithi: "பஞ்சமி", events: ["சங்கடஹர சதுர்த்தி"] },
    19: { tamil_date: "ஆடி 3", nakshatra: "சித்திரை", tithi: "ஷஷ்டி", events: ["ஷஷ்டி விரதம்"] },
    20: { tamil_date: "ஆடி 4", nakshatra: "சுவாதி", tithi: "ஸப்தமி", events: [] },
    21: { tamil_date: "ஆடி 5", nakshatra: "விசாகம்", tithi: "அஷ்டமி", events: [] },
    22: { tamil_date: "ஆடி 6", nakshatra: "அனுஷம்", tithi: "நவமி", events: ["ஸ்ரீ சுந்தரராஜப் பெருமாள் ஆடி பிரமோற்சவம் முதல் நாள் அன்ன வாகனம்"] },
    23: { tamil_date: "ஆடி 7", nakshatra: "கேட்டை", tithi: "நவமி", events: ["இரண்டாம் நாள் சிம்ம வாகனம்"] },
    24: { tamil_date: "ஆடி 8", nakshatra: "மூலம்", tithi: "தசமி", events: ["மூன்றாம் நாள் சேஷ வாகனம்"] },
    25: { tamil_date: "ஆடி 9", nakshatra: "பூராடம்", tithi: "ஏகாதசி", events: ["நான்காம் நாள் பெரிய திருவடி கருட வாகனம்", "ஏகாதசி"] },
    26: { tamil_date: "ஆடி 10", nakshatra: "உத்திராடம்", tithi: "த்வாதசி", events: ["ஐந்தாம் நாள் சிறிய திருவடி அனுமந்த வாகனம்", "பிரதோஷம்"] },
    27: { tamil_date: "ஆடி 11", nakshatra: "திருவோணம்", tithi: "த்ரயோதசி", events: ["ஆறாம் நாள் யானை வாகனம்"] },
    28: { tamil_date: "ஆடி 12", nakshatra: "அவிட்டம்", tithi: "சதுர்த்தசி", events: ["ஏழாம் நாள் சூர்ணோத்ஸவம் "] },
    29: { tamil_date: "ஆடி 13", nakshatra: "சதயம்", tithi: "பௌர்ணமி", events: ["எட்டாம் நாள் காலை நவநீத கிருஷ்ணன் சேவை இரவு குதிரை வாகனம்", "ஆடி பௌர்ணமி"] },
    30: { tamil_date: "ஆடி 14", nakshatra: "பூரட்டாதி", tithi: "பிரதமை", events: ["ஒன்பதாம் நாள் ரதாரோஹணம் & சயனப் பல்லக்கு"] },
    31: { tamil_date: "ஆடி 15", nakshatra: "உத்திரட்டாதி", tithi: "த்விதியை", events: ["பத்தாம் நாள் காலை தீர்த்தவாரி இரவு த்வஜாவரோஹணம்"] }
};

// Process July data
Object.keys(JULY_2026_DATA).forEach(day => {
    const data = JULY_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// August 2026 data from JSON with events
const AUGUST_2026_DATA = {
    1: { tamil_date: "ஆடி 16", nakshatra: "சதயம்", tithi: "த்ரிதியை", events: [] },
    2: { tamil_date: "ஆடி 17", nakshatra: "பூரட்டாதி", tithi: "சதுர்த்தி", events: ["சங்கடஹர சதுர்த்தி"] },
    3: { tamil_date: "ஆடி 18", nakshatra: "உத்திராடம்", tithi: "பஞ்சமி", events: ["ஆடி பெருக்கு"] },
    4: { tamil_date: "ஆடி 19", nakshatra: "ரேவதி", tithi: "ஷஷ்டி", events: [] },
    5: { tamil_date: "ஆடி 20", nakshatra: "அஸ்வினி", tithi: "ஸப்தமி", events: [] },
    6: { tamil_date: "ஆடி 21", nakshatra: "பரணி", tithi: "அஷ்டமி", events: [] },
    7: { tamil_date: "ஆடி 22", nakshatra: "கார்த்திகை", tithi: "நவமி", events: ["ஆடி கிருத்திகை"] },
    8: { tamil_date: "ஆடி 23", nakshatra: "ரோகிணி", tithi: "தசமி", events: [] },
    9: { tamil_date: "ஆடி 24", nakshatra: "மிருகசீரிடம்", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },
    10: { tamil_date: "ஆடி 25", nakshatra: "திருவாதிரை", tithi: "த்வாதசி", events: [] },
    11: { tamil_date: "ஆடி 26", nakshatra: "புனர்பூசம்", tithi: "சதுர்த்தசி", events: ["பிரதோஷம்"] },
    12: { tamil_date: "ஆடி 27", nakshatra: "பூசம்", tithi: "அமாவாசை", events: ["மாத சிவராத்திரி"] },
    13: { tamil_date: "ஆடி 28", nakshatra: "ஆயில்யம்", tithi: "பிரதமை", events: [] },
    14: { tamil_date: "ஆடி 29", nakshatra: "பூரம்", tithi: "த்விதியை", events: [] },
    15: { tamil_date: "ஆடி 30", nakshatra: "உத்திரம்", tithi: "த்ரிதியை", events: ["இந்திய சுதந்திர தினம்"] },
    16: { tamil_date: "ஆடி 31", nakshatra: "அஸ்தம்", tithi: "சதுர்த்தி", events: [] },
    17: { tamil_date: "ஆடி 32", nakshatra: "சித்திரை", tithi: "பஞ்சமி", events: ["சங்கடஹர சதுர்த்தி"] },
    18: { tamil_date: "ஆவணி 1", nakshatra: "சுவாதி", tithi: "ஷஷ்டி", events: [] },
    19: { tamil_date: "ஆவணி 2", nakshatra: "சுவாதி", tithi: "ஸப்தமி", events: [] },
    20: { tamil_date: "ஆவணி 3", nakshatra: "விசாகம்", tithi: "அஷ்டமி", events: [] },
    21: { tamil_date: "ஆவணி 4", nakshatra: "அனுஷம்", tithi: "நவமி", events: [] },
    22: { tamil_date: "ஆவணி 5", nakshatra: "கேட்டை", tithi: "தசமி", events: [] },
    23: { tamil_date: "ஆவணி 6", nakshatra: "மூலம்", tithi: "ஏகாதசி", events: [] },
    24: { tamil_date: "ஆவணி 7", nakshatra: "பூராடம்", tithi: "த்வாதசி", events: ["ஏகாதசி"] },
    25: { tamil_date: "ஆவணி 8", nakshatra: "உத்திராடம்", tithi: "த்வாதசி", events: ["பிரதோஷம்"] },
    26: { tamil_date: "ஆவணி 9", nakshatra: "திருவோணம்", tithi: "த்ரயோதசி", events: ["மீலாத்-உன்-நபி", "ஒணம்"] },
    27: { tamil_date: "ஆவணி 10", nakshatra: "அவிட்டம்", tithi: "த்ரயோதசி", events: [] },
    28: { tamil_date: "ஆவணி 11", nakshatra: "சதயம்", tithi: "பௌர்ணமி", events: ["கஜேந்திர மோட்சம்"] },
    29: { tamil_date: "ஆவணி 12", nakshatra: "பூரட்டாதி", tithi: "பிரதமை", events: [] },
    30: { tamil_date: "ஆவணி 13", nakshatra: "உத்திரட்டாதி", tithi: "த்விதியை", events: [] },
    31: { tamil_date: "ஆவணி 14", nakshatra: "ரேவதி", tithi: "த்ரிதியை", events: [] }
};

// Process August data
Object.keys(AUGUST_2026_DATA).forEach(day => {
    const data = AUGUST_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// September 2026 data from JSON with events
const SEPTEMBER_2026_DATA = {
    1: { tamil_date: "ஆவணி 15", nakshatra: "அஸ்வினி", tithi: "சதுர்த்தி", events: [] },
    2: { tamil_date: "ஆவணி 16", nakshatra: "பரணி", tithi: "பஞ்சமி", events: [] },
    3: { tamil_date: "ஆவணி 17", nakshatra: "கார்த்திகை", tithi: "சப்தமி", events: [] },
    4: { tamil_date: "ஆவணி 18", nakshatra: "ரோகிணி", tithi: "அஷ்டமி", events: ["கோகுளாஷ்டமி", "கிருஷ்ண ஜெயந்தி"] },
    5: { tamil_date: "ஆவணி 19", nakshatra: "மிருகசீரிடம்", tithi: "நவமி", events: [] },
    6: { tamil_date: "ஆவணி 20", nakshatra: "திருவாதிரை", tithi: "தசமி", events: [] },
    7: { tamil_date: "ஆவணி 21", nakshatra: "புனர்பூசம்", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },
    8: { tamil_date: "ஆவணி 22", nakshatra: "பூசம்", tithi: "த்வாதசி", events: ["பிரதோஷம்"] },
    9: { tamil_date: "ஆவணி 23", nakshatra: "ஆயில்யம்", tithi: "த்ரயோதசி", events: ["மாத சிவராத்திரி"] },
    10: { tamil_date: "ஆவணி 24", nakshatra: "மகம்", tithi: "சதுர்த்தசி", events: ["அமாவாசை"] },
    11: { tamil_date: "ஆவணி 25", nakshatra: "பூரம்", tithi: "அமாவாசை", events: [] },
    12: { tamil_date: "ஆவணி 26", nakshatra: "உத்திரம்", tithi: "பிரதமை", events: [] },
    13: { tamil_date: "ஆவணி 27", nakshatra: "அஸ்தம்", tithi: "த்விதியை", events: [] },
    14: { tamil_date: "ஆவணி 28", nakshatra: "சித்திரை", tithi: "த்ரிதியை", events: ["விநாயகர் சதுர்த்தி"] },
    15: { tamil_date: "ஆவணி 29", nakshatra: "சுவாதி", tithi: "சதுர்த்தி", events: [] },
    16: { tamil_date: "ஆவணி 30", nakshatra: "விசாகம்", tithi: "பஞ்சமி", events: [] },
    17: { tamil_date: "ஆவணி 31", nakshatra: "அனுஷம்", tithi: "ஷஷ்டி", events: ["புரட்டாசி மாதம் தொடக்கம்"] },
    18: { tamil_date: "புரட்டாசி 1", nakshatra: "கேட்டை", tithi: "சப்தமி", events: [] },
    19: { tamil_date: "புரட்டாசி 2", nakshatra: "மூலம்", tithi: "அஷ்டமி", events: [] },
    20: { tamil_date: "புரட்டாசி 3", nakshatra: "பூராடம்", tithi: "நவமி", events: [] },
    21: { tamil_date: "புரட்டாசி 4", nakshatra: "உத்திராடம்", tithi: "தசமி", events: ["ஏகாதசி"] },
    22: { tamil_date: "புரட்டாசி 5", nakshatra: "உத்திராடம்", tithi: "ஏகாதசி", events: [] },
    23: { tamil_date: "புரட்டாசி 6", nakshatra: "திருவோணம்", tithi: "த்வாதசி", events: [] },
    24: { tamil_date: "புரட்டாசி 7", nakshatra: "அவிட்டம்", tithi: "த்ரயோதசி", events: ["பிரதோஷம்"] },
    25: { tamil_date: "புரட்டாசி 8", nakshatra: "சதயம்", tithi: "சதுர்த்தி", events: ["ஆனந்த விரதம்"], image: anandhaviradham },
    26: { tamil_date: "புரட்டாசி 9", nakshatra: "பூரட்டாதி", tithi: "பௌர்ணமி", events: [] },
    27: { tamil_date: "புரட்டாசி 10", nakshatra: "உத்திரட்டாதி", tithi: "பிரதமை", events: [] },
    28: { tamil_date: "புரட்டாசி 11", nakshatra: "ரேவதி", tithi: "த்விதியை", events: [] },
    29: { tamil_date: "புரட்டாசி 12", nakshatra: "அஸ்வினி", tithi: "த்ரிதியை", events: [] },
    30: { tamil_date: "புரட்டாசி 13", nakshatra: "பரணி", tithi: "சதுர்த்தி", events: [] }
};

// Process September data
Object.keys(SEPTEMBER_2026_DATA).forEach(day => {
    const data = SEPTEMBER_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// October 2026 data from JSON with events
const OCTOBER_2026_DATA = {
    1: { tamil_date: "புரட்டாசி 14", nakshatra: "கார்த்திகை", tithi: "பஞ்சமி", events: [] },
    2: { tamil_date: "புரட்டாசி 15", nakshatra: "மிருகசீரிடம்", tithi: "ஷஷ்டி", events: ["காந்தி ஜெயந்தி"] },
    3: { tamil_date: "புரட்டாசி 16", nakshatra: "திருவாதிரை", tithi: "ஸப்தமி", events: [] },
    4: { tamil_date: "புரட்டாசி 17", nakshatra: "புனர்பூசம்", tithi: "நவமி", events: ["மகா நவமி"] },
    5: { tamil_date: "புரட்டாசி 18", nakshatra: "பூசம்", tithi: "தசமி", events: [] },
    6: { tamil_date: "புரட்டாசி 19", nakshatra: "ஆயில்யம்", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },
    7: { tamil_date: "புரட்டாசி 20", nakshatra: "மகம்", tithi: "த்வாதசி", events: ["பிரதோஷம்"] },
    8: { tamil_date: "புரட்டாசி 21", nakshatra: "பூரம்", tithi: "த்ரயோதசி", events: ["மாத சிவராத்திரி"] },
    9: { tamil_date: "புரட்டாசி 22", nakshatra: "உத்திரம்", tithi: "சதுர்த்தசி", events: ["அமாவாசை"] },
    10: { tamil_date: "புரட்டாசி 23", nakshatra: "அஸ்தம்", tithi: "அமாவாசை", events: [] },
    11: { tamil_date: "புரட்டாசி 24", nakshatra: "சித்திரை", tithi: "பிரதமை", events: ["நவராத்திரி முதல் நாள்"] },
    12: { tamil_date: "புரட்டாசி 25", nakshatra: "சுவாதி", tithi: "த்விதியை", events: ["நவராத்திரி இரண்டாம் நாள்"] },
    13: { tamil_date: "புரட்டாசி 26", nakshatra: "விசாகம்", tithi: "த்ரிதியை", events: ["நவராத்திரி மூன்றாம் நாள்", "சங்கடஹர சதுர்த்தி"] },
    14: { tamil_date: "புரட்டாசி 27", nakshatra: "அனுஷம்", tithi: "சதுர்த்தி", events: ["நவராத்திரி நான்காம் நாள்"] },
    15: { tamil_date: "புரட்டாசி 28", nakshatra: "கேட்டை", tithi: "பஞ்சமி", events: ["நவராத்திரி ஐந்தாம் நாள்"] },
    16: { tamil_date: "புரட்டாசி 29", nakshatra: "கேட்டை", tithi: "ஷஷ்டி", events: ["நவராத்திரி ஆறாம் நாள்"] },
    17: { tamil_date: "புரட்டாசி 30", nakshatra: "மூலம்", tithi: "ஸப்தமி", events: ["நவராத்திரி ஏழாம் நாள்"] },
    18: { tamil_date: "ஐப்பசி 1", nakshatra: "பூராடம்", tithi: "ஸப்தமி", events: ["நவராத்திரி எட்டாம் நாள்", "ஐப்பசி மாதம் தொடக்கம்"] },
    19: { tamil_date: "ஐப்பசி 2", nakshatra: "உத்திராடம்", tithi: "நவமி", events: ["நவராத்திரி ஒன்பதாம் நாள்", "ஆயுத பூஜை"] },
    20: { tamil_date: "ஐப்பசி 3", nakshatra: "திருவோணம்", tithi: "ஏகாதசி", events: ["விஜயதசமி", "ஏகாதசி"] },
    21: { tamil_date: "ஐப்பசி 4", nakshatra: "அவிட்டம்", tithi: "தசமி", events: ["பிரதோஷம்"] },
    22: { tamil_date: "ஐப்பசி 5", nakshatra: "சதயம்", tithi: "ஏகாதசி", events: ["மாத சிவராத்திரி"] },
    23: { tamil_date: "ஐப்பசி 6", nakshatra: "பூரட்டாதி", tithi: "த்வாதசி", events: [] },
    24: { tamil_date: "ஐப்பசி 7", nakshatra: "உத்திரட்டாதி", tithi: "த்ரயோதசி", events: [] },
    25: { tamil_date: "ஐப்பசி 8", nakshatra: "ரேவதி", tithi: "சதுர்த்தசி", events: [] },
    26: { tamil_date: "ஐப்பசி 9", nakshatra: "அஸ்வினி", tithi: "பௌர்ணமி", events: ["ஐப்பசி பௌர்ணமி"] },
    27: { tamil_date: "ஐப்பசி 10", nakshatra: "பரணி", tithi: "பிரதமை", events: [] },
    28: { tamil_date: "ஐப்பசி 11", nakshatra: "கார்த்திகை", tithi: "த்ரிதியை", events: ["சங்கடஹர சதுர்த்தி"] },
    29: { tamil_date: "ஐப்பசி 12", nakshatra: "ரோகிணி", tithi: "சதுர்த்தசி", events: [] },
    30: { tamil_date: "ஐப்பசி 13", nakshatra: "மிருகசீரிடம்", tithi: "பஞ்சமி", events: [] },
    31: { tamil_date: "ஐப்பசி 14", nakshatra: "திருவாதிரை", tithi: "ஷஷ்டி", events: [] }
};

// Process October data
Object.keys(OCTOBER_2026_DATA).forEach(day => {
    const data = OCTOBER_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// November 2026 data from JSON with events
const NOVEMBER_2026_DATA = {
    1: { tamil_date: "ஐப்பசி 15", nakshatra: "பூசம்", tithi: "ஸப்தமி", events: [] },
    2: { tamil_date: "ஐப்பசி 16", nakshatra: "அயில்யம்", tithi: "அஷ்டமி", events: [] },
    3: { tamil_date: "ஐப்பசி 17", nakshatra: "மகம்", tithi: "நவமி", events: [] },
    4: { tamil_date: "ஐப்பசி 18", nakshatra: "பூரம்", tithi: "தசமி", events: [] },
    5: { tamil_date: "ஐப்பசி 19", nakshatra: "உத்திரம்", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },
    6: { tamil_date: "ஐப்பசி 20", nakshatra: "அஸ்தம்", tithi: "த்வாதசி", events: ["பிரதோஷம்"] },
    7: { tamil_date: "ஐப்பசி 21", nakshatra: "சித்திரை", tithi: "த்ரயோதசி", events: [] },
    8: { tamil_date: "ஐப்பசி 22", nakshatra: "சுவாதி", tithi: "சதுர்த்தசி", events: ["வரதராஜப் பெருமாள் திருப்பதி அலங்கார சேவை", "தீபாவளி"] },
    9: { tamil_date: "ஐப்பசி 23", nakshatra: "சுவாதி", tithi: "அமாவாசை", events: [] },
    10: { tamil_date: "ஐப்பசி 24", nakshatra: "விசாகம்", tithi: "பிரதமை", events: [] },
    11: { tamil_date: "ஐப்பசி 25", nakshatra: "அனுஷம்", tithi: "த்விதியை", events: [] },
    12: { tamil_date: "ஐப்பசி 26", nakshatra: "கேட்டை", tithi: "த்ரிதியை", events: [] },
    13: { tamil_date: "ஐப்பசி 27", nakshatra: "மூலம்", tithi: "சதுர்த்தி", events: [] },
    14: { tamil_date: "ஐப்பசி 28", nakshatra: "பூராடம்", tithi: "பஞ்சமி", events: ["பிரதோஷம்"] },
    15: { tamil_date: "ஐப்பசி 29", nakshatra: "உத்திராடம்", tithi: "ஷஷ்டி", events: [] },
    16: { tamil_date: "ஐப்பசி 30", nakshatra: "திருவோணம்", tithi: "ஸப்தமி", events: [] },
    17: { tamil_date: "கார்த்திகை 1", nakshatra: "அவிட்டம்", tithi: "அஷ்டமி", events: ["கார்த்திகை மாதம் தொடக்கம்"] },
    18: { tamil_date: "கார்த்திகை 2", nakshatra: "சதயம்", tithi: "நவமி", events: [] },
    19: { tamil_date: "கார்த்திகை 3", nakshatra: "பூரட்டாதி", tithi: "நவமி", events: [] },
    20: { tamil_date: "கார்த்திகை 4", nakshatra: "பூரட்டாதி", tithi: "தசமி", events: ["ஏகாதசி"] },
    21: { tamil_date: "கார்த்திகை 5", nakshatra: "உத்திரட்டாதி", tithi: "ஏகாதசி", events: ["பிரதோஷம்"] },
    22: { tamil_date: "கார்த்திகை 6", nakshatra: "அஸ்வினி", tithi: "த்ரயோதசி", events: [] },
    23: { tamil_date: "கார்த்திகை 7", nakshatra: "பரணி", tithi: "சதுர்த்தசி", events: [] },
    24: { tamil_date: "கார்த்திகை 8", nakshatra: "கார்த்திகை", tithi: "பௌர்ணமி", events: ["பிரதோஷம்"] },
    25: { tamil_date: "கார்த்திகை 9", nakshatra: "ரோகிணி", tithi: "பிரதமை", events: [] },
    26: { tamil_date: "கார்த்திகை 10", nakshatra: "மிருகசீரிடம்", tithi: "த்விதியை", events: [] },
    27: { tamil_date: "கார்த்திகை 11", nakshatra: "திருவாதிரை", tithi: "த்ரிதியை", events: [] },
    28: { tamil_date: "கார்த்திகை 12", nakshatra: "புனர்பூசம்", tithi: "சதுர்த்தி", events: [] },
    29: { tamil_date: "கார்த்திகை 13", nakshatra: "பூசம்", tithi: "ஷஷ்டி", events: [] },
    30: { tamil_date: "கார்த்திகை 14", nakshatra: "ஆயில்யம்", tithi: "ஸப்தமி", events: [] }
};

// Process November data
Object.keys(NOVEMBER_2026_DATA).forEach(day => {
    const data = NOVEMBER_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// December 2026 data from JSON with events
const DECEMBER_2026_DATA = {
    1: { tamil_date: "கார்த்திகை 15", nakshatra: "மகம்", tithi: "அஷ்டமி", events: [] },
    2: { tamil_date: "கார்த்திகை 16", nakshatra: "பூரம்", tithi: "நவமி", events: [] },
    3: { tamil_date: "கார்த்திகை 17", nakshatra: "உத்திரம்", tithi: "தசமி", events: [] },
    4: { tamil_date: "கார்த்திகை 18", nakshatra: "அஸ்தம்", tithi: "ஏகாதசி", events: ["ஏகாதசி"] },
    5: { tamil_date: "கார்த்திகை 19", nakshatra: "சித்திரை", tithi: "த்வாதசி", events: ["பிரதோஷம்"] },
    6: { tamil_date: "கார்த்திகை 20", nakshatra: "சுவாதி", tithi: "த்ரயோதசி", events: ["மாத சிவராத்திரி"] },
    7: { tamil_date: "கார்த்திகை 21", nakshatra: "விசாகம்", tithi: "சதுர்த்தசி", events: [] },
    8: { tamil_date: "கார்த்திகை 22", nakshatra: "அனுஷம்", tithi: "அமாவாசை", events: ["அமாவாசை"] },
    9: { tamil_date: "கார்த்திகை 23", nakshatra: "கேட்டை", tithi: "பிரதமை", events: [] },
    10: { tamil_date: "கார்த்திகை 24", nakshatra: "மூலம்", tithi: "பிரதமை", events: [] },
    11: { tamil_date: "கார்த்திகை 25", nakshatra: "பூராடம்", tithi: "த்விதியை", events: [] },
    12: { tamil_date: "கார்த்திகை 26", nakshatra: "உத்திராடம்", tithi: "த்ரிதியை", events: ["சங்கடஹர சதுர்த்தி"] },
    13: { tamil_date: "கார்த்திகை 27", nakshatra: "திருவோணம்", tithi: "சதுர்த்தி", events: [] },
    14: { tamil_date: "கார்த்திகை 28", nakshatra: "அவிட்டம்", tithi: "பஞ்சமி", events: [] },
    15: { tamil_date: "கார்த்திகை 29", nakshatra: "அவிட்டம்", tithi: "ஷஷ்டி", events: [] },
    16: { tamil_date: "மார்கழி 1", nakshatra: "சதயம்", tithi: "ஸப்தமி", events: [] },
    17: { tamil_date: "மார்கழி 2", nakshatra: "பூரட்டாதி", tithi: "அஷ்டமி", events: ["மார்கழி மாதம் தொடக்கம்"] },
    18: { tamil_date: "மார்கழி 3", nakshatra: "உத்திரட்டாதி", tithi: "நவமி", events: [] },
    19: { tamil_date: "மார்கழி 4", nakshatra: "ரேவதி", tithi: "தசமி", events: ["ஏகாதசி"] },
    20: { tamil_date: "மார்கழி 5", nakshatra: "அஸ்வினி", tithi: "ஏகாதசி", events: ["பிரதோஷம்"] },
    21: { tamil_date: "மார்கழி 6", nakshatra: "பரணி", tithi: "த்வாதசி", events: ["மாத சிவராத்திரி"] },
    22: { tamil_date: "மார்கழி 7", nakshatra: "கார்த்திகை", tithi: "த்ரயோதசி", events: [] },
    23: { tamil_date: "மார்கழி 8", nakshatra: "ரோகிணி", tithi: "சதுர்த்தசி", events: ["திருவாதிரை"] },
    24: { tamil_date: "மார்கழி 9", nakshatra: "திருவாதிரை", tithi: "பௌர்ணமி", events: [] },
    25: { tamil_date: "மார்கழி 10", nakshatra: "புனர்பூசம்", tithi: "த்விதியை", events: ["கிறிஸ்துமஸ்"] },
    26: { tamil_date: "மார்கழி 11", nakshatra: "பூசம்", tithi: "த்ரிதியை", events: [] },
    27: { tamil_date: "மார்கழி 12", nakshatra: "ஆயில்யம்", tithi: "சதுர்த்தி", events: ["சங்கடஹர சதுர்த்தி"] },
    28: { tamil_date: "மார்கழி 13", nakshatra: "மகம்", tithi: "பஞ்சமி", events: ["ஸ்ரீ வாரி சேவா குழு பொது பஜனை"] },
    29: { tamil_date: "மார்கழி 14", nakshatra: "பூரம்", tithi: "ஷஷ்டி", events: [] },
    30: { tamil_date: "மார்கழி 15", nakshatra: "உத்திரம்", tithi: "ஸப்தமி", events: [] },
    31: { tamil_date: "மார்கழி 16", nakshatra: "அஸ்தம்", tithi: "அஷ்டமி", events: [] }
};

// Process December data
Object.keys(DECEMBER_2026_DATA).forEach(day => {
    const data = DECEMBER_2026_DATA[day];
    data.dayType = getDayType(data.events);
    data.isGovtHoliday = data.events.some(e => GOVT_HOLIDAY_NAMES.includes(e));
    data.festival = data.events.length > 0 ? data.events.join(", ") : null;
});

// Store all month data - COMPLETE 2026 CALENDAR
const PANCHANGAM_2026 = {
    0: JANUARY_2026_DATA,   // January
    1: FEBRUARY_2026_DATA,  // February
    2: MARCH_2026_DATA,     // March
    3: APRIL_2026_DATA,     // April
    4: MAY_2026_DATA,       // May
    5: JUNE_2026_DATA,      // June
    6: JULY_2026_DATA,      // July
    7: AUGUST_2026_DATA,    // August
    8: SEPTEMBER_2026_DATA, // September
    9: OCTOBER_2026_DATA,   // October
    10: NOVEMBER_2026_DATA, // November
    11: DECEMBER_2026_DATA  // December
};

// Automatically assign images for special days across all months
function assignSpecialImages() {
    const tamilMonthLastDays = {}; // Track last Friday for each Tamil month

    // First pass: Find Pournami days and collect Tamil month info
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];



            // Masi Magam Image Assignment
            if (data.tamil_date.startsWith("மாசி") && data.nakshatra === "மகம்") {
                // Skip March 3rd for Masi Magam image
                if (!(parseInt(month) === 2 && parseInt(day) === 3)) {
                    data.image = masimagam;
                    if (data.events && !data.events.includes("மாசி மகம்")) {
                        data.events.push("மாசி மகம்");
                        data.festival = data.events.join(", ");
                    }
                }
            }

            // Rama Navami Image Assignment
            // Month is Panguni, Thithi is Navami, and it must be before Pournami (March 27, 2026)
            if (data.tamil_date.startsWith("பங்குனி") && data.tithi === "நவமி") {
                const gregorianMonth = parseInt(month);
                const gregorianDay = parseInt(day);
                // In 2026, Panguni Shukla Navami is March 27
                if (gregorianMonth === 2 && gregorianDay === 27) {
                    data.image = ramanavami;
                    if (data.events && !data.events.includes("ஸ்ரீ ராம நவமி")) {
                        data.events.push("ஸ்ரீ ராம நவமி");
                        data.festival = data.events.join(", ");
                    }
                }
            }

            // Tamil New Year Image Assignment
            if (data.tamil_date === "சித்திரை 1") {
                data.image = tamilnewyear;
            }

            // Karthigai 1 Image Assignment
            if (data.tamil_date === "கார்த்திகை 1") {
                if (data.image) {
                    data.leftImage = karthigai_1;
                    data.secondaryImage = karthigai_1;
                } else {
                    data.image = karthigai_1;
                }
            }

            // Gajendra Motcham Image Assignment
            if (data.tamil_date.startsWith("ஆவணி") && (data.tithi === "பௌர்ணமி" || (data.events && data.events.includes("பௌர்ணமி")))) {
                data.image = gajendra_motcham;
            }

            // Panguni Uthiram Image Assignment - use both images
            if (data.tamil_date.startsWith("பங்குனி") && data.nakshatra === "உத்திரம்") {
                data.image = panguni_thirukalyanam; // Primary image
                data.secondaryImage = panguni_uthiram; // Secondary image
                data.leftImage = panguni_uthiram
                if (data.events && !data.events.includes("பங்குனி உத்திரம்")) {
                    data.events.push("பங்குனி உத்திரம்");
                    data.festival = data.events.join(", ");
                }
            }

            // Aavani Avittam - Find the date and assign image to next Wednesday
            if (data.tamil_date.startsWith("ஆவணி") && data.nakshatra === "அவிட்டம்") {
                // Calculate the next Wednesday after this date
                const avittamDate = new Date(2026, parseInt(month), parseInt(day));
                const avittamDayOfWeek = avittamDate.getDay();
                // 3 = Wednesday, find days until next Wednesday
                const daysUntilWednesday = avittamDayOfWeek <= 3 ? (3 - avittamDayOfWeek) : (10 - avittamDayOfWeek);

                if (daysUntilWednesday > 0) {
                    const nextWednesday = new Date(avittamDate);
                    nextWednesday.setDate(avittamDate.getDate() + daysUntilWednesday);

                    // Store for later assignment
                    const wedMonth = nextWednesday.getMonth();
                    const wedDay = nextWednesday.getDate();

                    // Find and assign to the Wednesday date
                    const wedMonthData = PANCHANGAM_2026[wedMonth];
                    if (wedMonthData && wedMonthData[wedDay]) {
                        wedMonthData[wedDay].gridImage = srinivasan; // For calendar grid thumbnail
                        wedMonthData[wedDay].image = srinivasan_2; // For modal primary
                        wedMonthData[wedDay].secondaryImage = srinivasan; // For modal carousel
                        if (!wedMonthData[wedDay].events.includes("ஶ்ரீநிவாசன் 108")) {
                            wedMonthData[wedDay].events.push("ஶ்ரீநிவாசன் 108 கலசாபிஷேகம்");
                        }
                    }
                }
            }

            // Thirumangai Alvar - Karthigai month with Karthigai nakshatra
            if (data.tamil_date.startsWith("கார்த்திகை") && data.nakshatra === "கார்த்திகை") {
                data.image = thirumangai_alvar;
                if (data.events && !data.events.includes("திருமங்கை ஆழ்வார்")) {
                    data.events.push("திருமங்கை ஆழ்வார் ஜெயந்தி");
                }

                // Add karthigai image to next day
                const nextDate = new Date(2026, parseInt(month), parseInt(day) + 1);
                const nextMonth = nextDate.getMonth();
                const nextDay = nextDate.getDate();

                if (PANCHANGAM_2026[nextMonth] && PANCHANGAM_2026[nextMonth][nextDay]) {
                    const nextDayData = PANCHANGAM_2026[nextMonth][nextDay];
                    if (nextDayData.image) {
                        nextDayData.leftImage = karthigai;
                        nextDayData.secondaryImage = karthigai;
                    } else {
                        nextDayData.image = karthigai;
                    }
                    if (nextDayData.events && !nextDayData.events.includes("கார்த்திகை தீபம்")) {
                        nextDayData.events.push("கார்த்திகை தீபம்");
                    }
                }
            }

            // Ramanujar Jayanthi - Chithirai month with Thiruvathirai nakshatra
            if (data.tamil_date.startsWith("சித்திரை") && data.nakshatra === "திருவாதிரை") {
                data.image = ramanujar_jeyanthi;
                if (data.events && !data.events.includes("ராமானுஜர் ஜெயந்தி")) {
                    data.events.push("ராமானுஜர் ஜெயந்தி");
                }
            }

            // Diwali - Add diwali image
            if (data.events && data.events.includes("தீபாவளி")) {
                if (data.image) {
                    data.leftImage = diwali;
                    data.secondaryImage = diwali;
                } else {
                    data.image = diwali;
                }
            }

            // Thaipusam - Thai month with Poosam nakshatra
            if (data.tamil_date.startsWith("தை") && data.nakshatra === "பூசம்") {
                if (data.image) {
                    data.leftImage = thaipusam;
                    data.secondaryImage = thaipusam;
                } else {
                    data.image = thaipusam;
                }
                if (data.events && !data.events.includes("தைப்பூசம்")) {
                    data.events.push("தைப்பூசம்");
                }
            }

            // Jestabisekam - Aani month with Kettai nakshatra
            if (data.tamil_date.startsWith("ஆனி") && data.nakshatra === "கேட்டை") {
                if (data.image) {
                    data.leftImage = jestabisekam;
                    data.secondaryImage = jestabisekam;
                } else {
                    data.image = jestabisekam;
                }
                if (data.events && !data.events.includes("ஜேஷ்டாபிஷேகம்")) {
                    data.events.push("ஜேஷ்டாபிஷேகம்");
                }
            }

            // Chakarathalwar Jeyanthi - Aani month with Chithirai nakshatra
            if (data.tamil_date.startsWith("ஆனி") && data.nakshatra === "சித்திரை") {
                if (data.image) {
                    data.leftImage = chakaram;
                    data.secondaryImage = chakaram;
                } else {
                    data.image = chakaram;
                }
                if (data.events && !data.events.includes("சக்கரத்தாழ்வார் ஜெயந்தி")) {
                    data.events.push("சக்கரத்தாழ்வார் ஜெயந்தி");
                }
            }

            // Laksharjanai - Karthigai month with Thiruvonam nakshatra
            if (data.tamil_date.startsWith("கார்த்திகை") && data.nakshatra === "திருவோணம்") {
                if (data.image) {
                    data.leftImage = laksh_arjanai;
                    data.secondaryImage = laksh_arjanai;
                } else {
                    data.image = laksh_arjanai;
                }
                if (data.events && !data.events.includes("லக்ஷார்ஜனை")) {
                    data.events.push("லக்ஷார்ஜனை");
                }
            }
            if (data.tamil_date.startsWith("மார்கழி") && data.tithi === "ஏகாதசி" && parseInt(month) === 11) {
                if (data.image) {
                    data.leftImage = vaigundam;
                    data.secondaryImage = vaigundam;
                } else {
                    data.image = vaigundam;
                }
                if (data.events && !data.events.includes("வைகுண்ட ஏகாதசி")) {
                    data.events.push("வைகுண்ட ஏகாதசி");
                }
            }

            // Krishna Jayanthi (Gokulashtami) - Avani + Rohini + Ashtami
            if (data.tamil_date.startsWith("ஆவணி") && data.nakshatra === "ரோகிணி" && data.tithi === "அஷ்டமி") {
                if (data.image) {
                    data.leftImage = krishna_jayanthi;
                    data.secondaryImage = krishna_jayanthi;
                } else {
                    data.image = krishna_jayanthi;
                }
                // if (data.events && !data.events.includes("கிருஷ்ணர் ஜெயந்தி")) {
                //     data.events.push("கிருஷ்ணர் ஜெயந்தி");
                // }

                // Also add Uriyadi Urchavam for next day
                const gokulaDate = new Date(2026, parseInt(month), parseInt(day));
                const uriyadiDate = new Date(gokulaDate);
                uriyadiDate.setDate(uriyadiDate.getDate() + 1);

                const um = uriyadiDate.getMonth();
                const ud = uriyadiDate.getDate();

                if (PANCHANGAM_2026[um] && PANCHANGAM_2026[um][ud]) {
                    const uriyadiData = PANCHANGAM_2026[um][ud];
                    if (uriyadiData.image) {
                        uriyadiData.leftImage = uriyadi;
                        uriyadiData.secondaryImage = uriyadi;
                    } else {
                        uriyadiData.image = uriyadi;
                    }
                    if (uriyadiData.events && !uriyadiData.events.includes("உரியடி உற்சவம்")) {
                        uriyadiData.events.push("உரியடி உற்சவம்");
                    }
                }
            }

            // Track Aipasi Amavasai for Diwali Garudan (4 days after)
            if (data.tamil_date.startsWith("ஐப்பசி") && data.tithi === "அமாவாசை") {
                // Calculate the date 4 days after this
                const amavasaiDate = new Date(2026, parseInt(month), parseInt(day));
                const garudanDate = new Date(amavasaiDate);
                garudanDate.setDate(garudanDate.getDate() + 4);

                const gm = garudanDate.getMonth();
                const gd = garudanDate.getDate();

                if (PANCHANGAM_2026[gm] && PANCHANGAM_2026[gm][gd]) {
                    const garudanData = PANCHANGAM_2026[gm][gd];
                    if (garudanData.image) {
                        garudanData.leftImage = diwali_garudan;
                        garudanData.secondaryImage = diwali_garudan;
                    } else {
                        garudanData.image = diwali_garudan;
                    }
                    if (garudanData.events && !garudanData.events.includes("நாக பஞ்சமி")) {
                        garudanData.events.push("நாக பஞ்சமி");
                    }
                }
            }

            // Sri Math Nadanagopala Nayaki Swamigal Jeyanthi - Margazhi month with Mirugasiridam nakshatra
            if (data.tamil_date.startsWith("மார்கழி") && data.nakshatra === "மிருகசீரிடம்") {
                if (data.image) {
                    data.leftImage = nadanagopal;
                    data.secondaryImage = nadanagopal;
                } else {
                    data.image = nadanagopal;
                }
                if (data.events && !data.events.includes("ஸ்ரீ மந் நடன கோபால நாயகி சுவாமிகள் ஜெயந்தி")) {
                    data.events.push("ஸ்ரீ மந் நடன கோபால நாயகி சுவாமிகள் ஜெயந்தி");
                }
            }

            const gregorianDay = parseInt(day);
            const date = new Date(2026, parseInt(month), gregorianDay);
            const dayOfWeek = date.getDay();

            // Puratasi Saturdays - assign puratasi_1 to puratasi_4 based on Saturday count
            if (dayOfWeek === 6 && data.tamil_date.startsWith("புரட்டாசி")) { // Saturday
                // Track and count Puratasi Saturdays
                if (!data._puratasiSaturday) {
                    // We'll need a second pass for this, mark it for now
                    data._isPuratasiSaturday = true;
                }
            }

            if (dayOfWeek === 5) { // Friday
                const tamilDateParts = data.tamil_date.split(" ");
                const tamilMonthName = tamilDateParts[0];
                const tamilDayNum = parseInt(tamilDateParts[1]) || 0;

                if (!tamilMonthLastDays[tamilMonthName]) {
                    tamilMonthLastDays[tamilMonthName] = {
                        month: parseInt(month),
                        day: gregorianDay,
                        tamilDay: tamilDayNum,
                        data: data
                    };
                } else {
                    // Compare Tamil day numbers - keep the one with higher Tamil day
                    if (tamilDayNum > tamilMonthLastDays[tamilMonthName].tamilDay) {
                        tamilMonthLastDays[tamilMonthName] = {
                            month: parseInt(month),
                            day: gregorianDay,
                            tamilDay: tamilDayNum,
                            data: data
                        };
                    }
                }
            }
        });
    });

    // Second pass: Assign unjal_sevai to last Friday of each Tamil month
    // Special case for Aadi month - use aadilastvelli image
    Object.keys(tamilMonthLastDays).forEach(tamilMonth => {
        const info = tamilMonthLastDays[tamilMonth];
        if (info.data) {
            if (tamilMonth === "ஆடி") {
                // Special image for Aadi last Friday
                info.data.image = aadilastvelli;
                if (!info.data.events.includes("ஆடி கடை வெள்ளி ஊஞ்சல் சேவை")) {
                    info.data.events.push("ஆடி கடை வெள்ளி ஊஞ்சல் சேவை");
                    info.data.festival = info.data.events.join(", ");
                }
            } else if (!info.data.image) {
                // Regular unjal_sevai for other months
                info.data.image = unjal_sevai;
                if (!info.data.events.includes("ஊஞ்சல் சேவை")) {
                    info.data.events.push("ஊஞ்சல் சேவை");
                    info.data.festival = info.data.events.join(", ");
                }
            }
        }
    });

    // Vaikasi Vaganam Image sequence Logic
    let vaikasiAmavasai = null;
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("வைகாசி") &&
                (data.tithi === "அமாவாசை" || (data.events && data.events.includes("அமாவாசை")))) {
                if (!vaikasiAmavasai) {
                    vaikasiAmavasai = { month: parseInt(month), day: parseInt(day) };
                }
            }
        });
    });

    if (vaikasiAmavasai) {
        const vaganamImages = [day0, day1, day2, day3, day4, day5, day6, day7, day8, day9, day10, day11, day12, day13, day14, day15, day16, day17, day18, day19, day20];
        // const vaganamNames = [
        //     "காப்புக் கட்டு", "அன்ன வாகனம்", "சிம்ம வாகனம்", "சேஷ வாகனம்", "கருட வாகனம்",
        //     "அனுமந்த வாகனம்", "யானை வாகனம்", "திருகல்யாணம்", "வெண்ணெய்தாழி",
        //     "குதிரை வாகனம்", "தீர்த்தவாரி", "இரவு வைகை எழுந்தருளல்", "குதிரை வாகனம்", "மன்டுக மகரிஷி மோட்சம்", "கருட வாகனம்", "அனுமந்த வாகனம்", "கள்ளர் திருக்கோலம் (கோவிலை நோக்கி)", "கண்ணாடி சேவை", "உற்சவ சாந்தி", "காந்தாடி உற்சவம்"
        // ];

        for (let i = 0; i < 21; i++) {
            // Amavasai + 3 = Day 0 (May 16 + 3 = May 19), Day 1 starts at +4
            const startDate = new Date(2026, vaikasiAmavasai.month, vaikasiAmavasai.day + 2 + i);
            const m = startDate.getMonth();
            const d = startDate.getDate();

            if (PANCHANGAM_2026[m] && PANCHANGAM_2026[m][d]) {
                const dayData = PANCHANGAM_2026[m][d];
                dayData.image = vaganamImages[i];

                // Day 17 has 2 images for carousel
                if (i === 18) {
                    dayData.secondaryImage = day18_1;
                }

                // if (!dayData.events.includes(vaganamNames[i])) {
                //     dayData.events.push(vaganamNames[i]);
                //     dayData.festival = dayData.events.length > 0 ? dayData.events.join(", ") : null;
                // }
            }
        }
    }

    // Panguni Dhani Image Assignment
    // 4th day from the start of Panguni Uthiram
    let panguniUthiramStart = null;
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("பங்குனி") && data.nakshatra === "உத்திரம்") {
                if (!panguniUthiramStart) {
                    panguniUthiramStart = { month: parseInt(month), day: parseInt(day) };
                }
            }
        });
    });

    if (panguniUthiramStart) {
        // Find 4th day from start (March 31 + 4 = April 4)
        const dhaniDate = new Date(2026, panguniUthiramStart.month, panguniUthiramStart.day + 4);
        const m = dhaniDate.getMonth();
        const d = dhaniDate.getDate();

        if (PANCHANGAM_2026[m] && PANCHANGAM_2026[m][d]) {
            const dayData = PANCHANGAM_2026[m][d];
            if (!dayData.image) {
                dayData.image = panguni_dhani;
            }
        }
    }

    // Puratasi Saturdays - assign puratasi_1 to puratasi_4 for each Saturday
    const puratasiSaturdayImages = [puratasi_1, puratasi_2, puratasi_3, puratasi_4];

    // Collect and sort Puratasi Saturdays
    const puratasiSaturdays = [];
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("புரட்டாசி")) {
                const gregorianDay = parseInt(day);
                const date = new Date(2026, parseInt(month), gregorianDay);
                const dayOfWeek = date.getDay();
                if (dayOfWeek === 6) { // Saturday
                    puratasiSaturdays.push({ month: parseInt(month), day: gregorianDay });
                }
            }
        });
    });

    // Sort by date and assign images
    puratasiSaturdays.sort((a, b) => a.month !== b.month ? a.month - b.month : a.day - b.day);
    puratasiSaturdays.forEach((sat, index) => {
        if (index < 4 && PANCHANGAM_2026[sat.month] && PANCHANGAM_2026[sat.month][sat.day]) {
            const dayData = PANCHANGAM_2026[sat.month][sat.day];
            if (dayData.image) {
                dayData.leftImage = puratasiSaturdayImages[index];
                dayData.secondaryImage = puratasiSaturdayImages[index];
            } else {
                dayData.image = puratasiSaturdayImages[index];
            }
            if (dayData.events && !dayData.events.includes("புரட்டாசி சனி")) {
                dayData.events.push("புரட்டாசி சனி");
            }
        }
    });

    // Chithirai Pournami Sequence (pmk_day_1 to pmk_day_11)
    // Day 6 (pmk_day_6) is Pournami, Days 1-5 before, Days 7-11 after
    let chithiraiPournami = null;
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("சித்திரை") && data.tithi === "பௌர்ணமி") {
                if (!chithiraiPournami) {
                    chithiraiPournami = { month: parseInt(month), day: parseInt(day) };
                }
            }
        });
    });

    if (chithiraiPournami) {
        const pmkImages = [pmk_day_1, pmk_day_2, pmk_day_3, pmk_day_4, pmk_day_5, pmk_day_6, pmk_day_7, pmk_day_8, pmk_day_9, pmk_day_10, pmk_day_11];
        for (let i = 0; i < 11; i++) {
            // Day 6 (index 5) is Pournami day, so offset = day - 5 + i
            const targetDate = new Date(2026, chithiraiPournami.month, chithiraiPournami.day - 5 + i);
            const m = targetDate.getMonth();
            const d = targetDate.getDate();

            if (PANCHANGAM_2026[m] && PANCHANGAM_2026[m][d]) {
                const dayData = PANCHANGAM_2026[m][d];

                // Check if image already exists (from Eswaran Kovil)
                if (dayData.image) {
                    // Don't overwrite - add pmk image as secondary/left
                    dayData.leftImage = pmkImages[i];
                    if (!dayData.imageArray) {
                        dayData.imageArray = [dayData.image, pmkImages[i]];
                    } else {
                        dayData.imageArray.push(pmkImages[i]);
                    }
                } else {
                    dayData.image = pmkImages[i];
                }

                // Add secondary image for Day 10 (index 9)
                if (i === 9) {
                    dayData.secondaryImage = pmk_day_10_1;
                }
            }
        }
    }

    // Eswaran Kovil 10-day sequence (April 21-30, 2026)
    // Runs after Chithirai Pournami so it can detect existing images
    let chithiraiChithirai = null;
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("சித்திரை") && data.nakshatra === "சித்திரை") {
                if (!chithiraiChithirai) {
                    chithiraiChithirai = { month: parseInt(month), day: parseInt(day) };
                }
            }
        });
    });

    if (chithiraiChithirai) {
        // Each day with its images [primary, ...additional images for carousel]
        const eswaranImagesPerDay = [
            [pmk_eswaran_kovil_1], // Day 1
            [pmk_eswaran_kovil_2], // Day 2
            [pmk_eswaran_kovil_3, pmk_eswaran_kovil_3_1], // Day 3
            [pmk_eswaran_kovil_4, pmk_eswaran_kovil_4_1], // Day 4
            [pmk_eswaran_kovil_5, pmk_eswaran_kovil_5_1], // Day 5
            [pmk_eswaran_kovil_6], // Day 6
            [pmk_eswaran_kovil_7], // Day 7
            [pmk_eswaran_kovil_8], // Day 8
            [pmk_eswaran_kovil_9], // Day 9
            [pmk_eswaran_kovil_10], // Day 10 (Chithirai nakshatra day)
            [pmk_eswaran_kovil_11] // Day 11 (day after Chithirai nakshatra)
        ];

        // Assign images for 11 days: Day 1 starts 10 days before Chithirai-Chithirai, ending on Chithirai nakshatra day
        for (let i = 0; i < 11; i++) {
            const targetDate = new Date(2026, chithiraiChithirai.month, chithiraiChithirai.day - 10 + i);
            const m = targetDate.getMonth();
            const d = targetDate.getDate();

            if (PANCHANGAM_2026[m] && PANCHANGAM_2026[m][d]) {
                const dayData = PANCHANGAM_2026[m][d];
                const dayImages = eswaranImagesPerDay[i];

                if (dayData.image) {
                    // Existing image on right, Eswaran Kovil on left
                    dayData.leftImage = dayImages[0];
                    // Include existing image + all Eswaran Kovil images in carousel
                    dayData.imageArray = [dayData.image, ...dayImages];
                } else {
                    dayData.image = dayImages[0];
                    // Store additional images for carousel if more than 1
                    if (dayImages.length > 1) {
                        dayData.imageArray = dayImages;
                    }
                }
            }
        }
    }

    // Aadi Pournami Sequence (aadi1 to aadi8)
    let aadiPournami = null;
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("ஆடி") && (data.tithi === "பௌர்ணமி" || (data.events && data.events.includes("பௌர்ணமி")))) {
                if (!aadiPournami) {
                    aadiPournami = { month: parseInt(month), day: parseInt(day) };
                }
            }
        });
    });

    if (aadiPournami) {
        const aadiImages = [aadi1, aadi2, aadi3, aadi4, aadi5, aadi6, aadi7, aadi8, aadi9, aadi10];
        for (let i = 0; i < 10; i++) {
            // Sequence starts 7 days before Pournami (Pournami is day 8, index 7)
            const targetDate = new Date(2026, aadiPournami.month, aadiPournami.day - 8 + i);
            const m = targetDate.getMonth();
            const d = targetDate.getDate();

            if (PANCHANGAM_2026[m] && PANCHANGAM_2026[m][d]) {
                const dayData = PANCHANGAM_2026[m][d];
                // For aadi8 (Pournami day, index 7), always assign the image
                if (i === 7) {
                    dayData.image = aadiImages[i];
                } else if (!dayData.image) {
                    // For other days, don't overwrite if image already exists
                    dayData.image = aadiImages[i];
                }
            }
        }
    }

    // Aadi Pooram - After Aadi Pournami to properly handle secondary images
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("ஆடி") && data.nakshatra === "பூரம்") {
                if (data.image && data.image !== aadipooram) {
                    // If another image exists (from Aadi Pournami), add aadipooram as secondary
                    data.leftImage = aadipooram;
                    data.secondaryImage = aadipooram;
                } else if (!data.image) {
                    data.image = aadipooram;
                }
                if (data.events && !data.events.includes("ஆடி பூரம்")) {
                    data.events.push("ஆடி பூரம்");
                }
            }
        });
    });

    // Aadi Amavasai - Aadi month with Amavasai tithi
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date.startsWith("ஆடி") && (data.tithi === "அமாவாசை" || (data.events && data.events.includes("அமாவாசை")))) {
                if (data.image && data.image !== aadiamavasai) {
                    // If another image exists, add aadiamavasai as secondary
                    data.leftImage = aadiamavasai;
                    data.secondaryImage = aadiamavasai;
                } else if (!data.image) {
                    data.image = aadiamavasai;
                }
                if (data.events && !data.events.includes("ஆடி அமாவாசை")) {
                    data.events.push("ஆடி அமாவாசை");
                }
            }
        });
    });

    // Garuda Panchami - Aadi month second Panchami tithi
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date === "ஆடி 32" && data.tithi === "பஞ்சமி") {
                if (data.image) {
                    data.leftImage = garudaPanjami;
                    data.secondaryImage = garudaPanjami;
                } else {
                    data.image = garudaPanjami;
                }
                if (data.events && !data.events.includes("கருட பஞ்சமி")) {
                    data.events.push("கருட பஞ்சமி");
                    data.festival = data.events.join(", ");
                }
            }
        });
    });

    // Vijayadhasami Sequence (aadi1 to aadi9 + vijaya_dhasami)
    let vijayadhasami = null;
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.events && data.events.includes("விஜயதசமி")) {
                if (!vijayadhasami) {
                    vijayadhasami = { month: parseInt(month), day: parseInt(day) };
                }
            }
        });
    });

    if (vijayadhasami) {
        const navaratriImages = [navarathri_1, navarathri_2, navarathri_3, navarathri_4, navarathri_5, navarathri_6, navarathri_7, navarathri_8, navarathri_9];
        // Assign aadi1-aadi9 to the 9 days before Vijayadhasami
        for (let i = 0; i < 9; i++) {
            const targetDate = new Date(2026, vijayadhasami.month, vijayadhasami.day - 9 + i);
            const m = targetDate.getMonth();
            const d = targetDate.getDate();

            if (PANCHANGAM_2026[m] && PANCHANGAM_2026[m][d]) {
                const dayData = PANCHANGAM_2026[m][d];
                dayData.image = navaratriImages[i];
            }
        }
        // Assign vijaya_dhasami image to the day itself
        if (PANCHANGAM_2026[vijayadhasami.month] && PANCHANGAM_2026[vijayadhasami.month][vijayadhasami.day]) {
            PANCHANGAM_2026[vijayadhasami.month][vijayadhasami.day].image = vijaya_dhasami;
        }
    }

    // Mandala Poojai Assignment (41st day from Karthigai 1)
    let karthigaiStart = null;
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            if (data.tamil_date === "கார்த்திகை 1") {
                if (!karthigaiStart) {
                    karthigaiStart = { month: parseInt(month), day: parseInt(day) };
                }
            }
        });
    });

    if (karthigaiStart) {
        // Calculation: Karthigai 1 is Day 1. 41st day is Karthigai 1 + 40 days.
        const targetDate = new Date(2026, karthigaiStart.month, karthigaiStart.day + 40);
        const m = targetDate.getMonth();
        const d = targetDate.getDate();

        if (PANCHANGAM_2026[m] && PANCHANGAM_2026[m][d]) {
            const dayData = PANCHANGAM_2026[m][d];
            dayData.image = mandala_poojai;
            if (!dayData.events.includes("மண்டல பூஜை")) {
                dayData.events.push("மண்டல பூஜை");
                dayData.festival = dayData.events.join(", ");
            }
        }

        // Srivari Bajanai - Next day of Mandala Poojai (Day 42)
        const nextDate = new Date(2026, karthigaiStart.month, karthigaiStart.day + 41);
        const nm = nextDate.getMonth();
        const nd = nextDate.getDate();

        if (PANCHANGAM_2026[nm] && PANCHANGAM_2026[nm][nd]) {
            const nextDayData = PANCHANGAM_2026[nm][nd];
            if (!nextDayData.image) {
                nextDayData.image = srivari_bajanai;
            }
        }
    }

    // Second pass: Assign Pournami images after all other festivals are assigned
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            // Skip April (month 3), August (month 7), May 30th, and March 3rd for Pournami images
            if (parseInt(month) === 3 || parseInt(month) === 7 || (parseInt(month) === 4 && parseInt(day) === 30) || (parseInt(month) === 2 && parseInt(day) === 3)) {
                return;
            }
            // Special case: Assign Pournami to March 2nd (even though March 3rd is actual Pournami)
            if (parseInt(month) === 2 && parseInt(day) === 2) {
                if (data.image) {
                    if (data.image !== punnim) {
                        data.leftImage = punnim;
                        data.secondaryImage = punnim;
                    }
                } else {
                    data.image = punnim;
                }
            }
            // Add punnim image for Pournami days (priority to existing image, add as secondary if exists)
            if (data.tithi === "பௌர்ணமி" || (data.events && data.events.some(e => e.includes("பௌர்ணமி")))) {
                if (data.image) {
                    if (data.image !== punnim) {
                        data.leftImage = punnim;
                        data.secondaryImage = punnim;
                    }
                } else {
                    data.image = punnim;
                }
            }
        });
    });

    // Final pass: Add Pournami Purappadu event for all Pournami days (including Masi Magam)
    Object.keys(PANCHANGAM_2026).forEach(month => {
        const monthData = PANCHANGAM_2026[month];
        Object.keys(monthData).forEach(day => {
            const data = monthData[day];
            // Skip April (month 3), August (month 7), May 30th, and March 3rd for Pournami events
            if (parseInt(month) === 3 || parseInt(month) === 7 || (parseInt(month) === 4 && parseInt(day) === 30) || (parseInt(month) === 2 && parseInt(day) === 3)) {
                return;
            }
            // Special case: Add Pournami event to March 2nd (even though March 3rd is actual Pournami)
            if (parseInt(month) === 2 && parseInt(day) === 2) {
                if (!data.events.includes("பௌர்ணமி புறப்பாடு") && !data.events.includes("ஸ்ரீ வரதராஜப் பெருமாள் பௌர்ணமி புறப்பாடு")) {
                    data.events.push("பௌர்ணமி புறப்பாடு");
                    data.festival = data.events.join(", ");
                }
            }
            // Add "பௌர்ணமி புறப்பாடு" event for all Pournami days
            // This includes days where punnim is primary, secondary, or left image
            if (data.tithi === "பௌர்ணமி" || (data.events && data.events.some(e => e.includes("பௌர்ணமி")))) {
                // Special case for May 1st and July 29th - use Sri Varadharajaperumal event
                const eventText = ((parseInt(month) === 4 && parseInt(day) === 1) || (parseInt(month) === 6 && parseInt(day) === 29))
                    ? "ஸ்ரீ வரதராஜப் பெருமாள் பௌர்ணமி புறப்பாடு"
                    : "பௌர்ணமி புறப்பாடு";

                if (!data.events.includes(eventText) && !data.events.includes("பௌர்ணமி புறப்பாடு") && !data.events.includes("ஸ்ரீ வரதராஜப் பெருமாள் பௌர்ணமி புறப்பாடு")) {
                    data.events.push(eventText);
                    // Update festival string to reflect changes
                    data.festival = data.events.join(", ");
                }
            }
        });
    });
}

// Run the automatic image assignment
assignSpecialImages();

// Get Panchangam data for a specific date
export function getPanchangamData(year, month, day) {
    const monthData = PANCHANGAM_2026[month];

    if (!monthData || !monthData[day]) {
        return {
            tamil_date: "---",
            nakshatra: "---",
            tithi: "---",
            events: [],
            festival: null,
            dayType: DAY_TYPES.REGULAR
        };
    }

    return monthData[day];
}

// Get Tamil date for a specific Gregorian date (from JSON data)
export function getTamilDate(year, month, day) {
    const data = getPanchangamData(year, month, day);
    if (data.tamil_date === "---") {
        return { day: day, month: "---", monthEn: "---" };
    }

    const parts = data.tamil_date.split(" ");
    const tamilMonth = parts[0];
    const tamilDay = parseInt(parts[1]) || day;

    const monthMap = {
        "சித்திரை": "Chithirai",
        "வைகாசி": "Vaikasi",
        "ஆனி": "Aani",
        "ஆடி": "Aadi",
        "ஆவணி": "Aavani",
        "புரட்டாசி": "Purattasi",
        "ஐப்பசி": "Aippasi",
        "கார்த்திகை": "Karthigai",
        "மார்கழி": "Margazhi",
        "தை": "Thai",
        "மாசி": "Maasi",
        "பங்குனி": "Panguni"
    };

    return {
        day: tamilDay,
        month: tamilMonth,
        monthEn: monthMap[tamilMonth] || tamilMonth
    };
}

// Get Tamil months that span a Gregorian month
export function getTamilMonthsInGregorianMonth(year, month) {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const uniqueMonths = [];

    for (let day = 1; day <= daysInMonth; day++) {
        const tamilDate = getTamilDate(year, month, day);
        if (tamilDate.month !== "---" && !uniqueMonths.find(m => m.name === tamilDate.month)) {
            uniqueMonths.push({ name: tamilDate.month, nameEn: tamilDate.monthEn });
        }
    }

    return uniqueMonths;
}
